import type { SVGComponent } from "@calcom/types/SVGComponent";

export const StarOutlineIcon: SVGComponent = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2123 0.838975C5.50372 0.13831 6.49629 0.13831 6.78771 0.838975L7.98168 3.70963L11.0808 3.95808C11.8372 4.01873 12.1439 4.96271 11.5676 5.45639L9.20643 7.47901L9.92781 10.5032C10.1039 11.2414 9.30088 11.8248 8.65328 11.4292L6 9.80861L3.34673 11.4292C2.69913 11.8248 1.89612 11.2414 2.0722 10.5032L2.79358 7.47901L0.432383 5.45639C-0.143933 4.96272 0.162785 4.01873 0.919213 3.95808L4.01832 3.70963L5.2123 0.838975ZM6 1.67926L4.94163 4.22389C4.81877 4.51927 4.54099 4.7211 4.2221 4.74666L1.47495 4.9669L3.56799 6.75981C3.81095 6.96793 3.91705 7.29449 3.84283 7.60567L3.20337 10.2864L5.55531 8.84986C5.82832 8.6831 6.17169 8.6831 6.4447 8.84986L8.79664 10.2864L8.15718 7.60567C8.08295 7.29448 8.18906 6.96793 8.43202 6.75981L10.5251 4.9669L7.77791 4.74666C7.45902 4.7211 7.18123 4.51927 7.05838 4.22389L6 1.67926Z"
      fill="#81888F"
    />
  </svg>
);

export const HomeIcon: SVGComponent = (props) => (
  <svg
    width="800"
    height="800"
    viewBox="0 0 800 800"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M66.666 406.798C66.666 330.518 66.666 292.377 83.9727 260.759C101.279 229.142 132.898 209.518 196.134 170.272L262.8 128.897C329.646 87.411 363.069 66.668 399.999 66.668C436.929 66.668 470.353 87.411 537.199 128.897L603.866 170.272C667.103 209.518 698.719 229.142 716.026 260.759C733.333 292.377 733.333 330.518 733.333 406.798V457.501C733.333 587.528 733.333 652.545 694.279 692.938C655.229 733.335 592.373 733.335 466.666 733.335H333.333C207.625 733.335 144.771 733.335 105.718 692.938C66.666 652.545 66.666 587.528 66.666 457.501V406.798Z"
      stroke="#8A8D98"
      strokeWidth="55"
    />
    <path d="M500 600H300" stroke="#8A8D98" strokeWidth="55" strokeLinecap="round" />
  </svg>
);

export const InsightsIcon: SVGComponent = (props) => (
  <svg
    width="801"
    height="801"
    viewBox="0 0 801 801"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M333.401 34.4V331.9C333.481 341.018 329.944 349.797 323.566 356.313C317.187 362.829 308.486 366.552 299.368 366.667H34.001C27.521 366.655 21.1849 364.756 15.7676 361.2C9.92665 357.354 5.37034 351.848 2.68521 345.391C7.87278e-05 338.933 -0.690983 331.82 0.700978 324.967C1.70098 318.5 3.06764 312.133 4.80098 305.833C20.9189 234.804 55.5195 169.295 105.099 115.94C154.679 62.585 217.477 23.2782 287.134 2C291.095 0.750529 295.215 0.0769725 299.368 0C303.863 0.0174377 308.311 0.921796 312.456 2.66125C316.601 4.4007 320.362 6.94105 323.524 10.1367C326.685 13.3324 329.185 17.1205 330.88 21.2841C332.575 25.4477 333.432 29.9048 333.401 34.4Z"
      fill="white"
      strokeWidth="55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M798.066 361.666C789.139 278.117 754.586 199.376 699.146 136.237C643.706 73.0986 570.093 28.6548 488.4 8.99947C474.666 5.66614 460.733 3.06614 446.733 1.33281C438.258 -0.329685 429.541 -0.329685 421.066 1.33281C414.186 3.28196 408.254 7.67768 404.387 13.6934C400.519 19.7091 398.983 26.9305 400.066 33.9995V400.333C400.103 404.705 399.263 409.04 397.596 413.082C395.93 417.124 393.471 420.791 390.364 423.867C387.257 426.943 383.565 429.365 379.506 430.991C375.448 432.617 371.104 433.413 366.733 433.333H31.7331C-18.6003 433.333 3.73306 497.166 13.0664 524.833C32.8603 584.241 66.2503 638.209 110.578 682.438C154.906 726.668 208.947 759.938 268.4 779.599C354.156 807.911 446.896 806.872 531.996 776.646C617.096 746.42 689.715 688.728 738.4 612.666C778.665 548.917 800.046 475.066 800.066 399.666C800.066 386.999 799.4 374.299 798.066 361.666ZM395.4 732.333C324.227 732.417 254.851 709.99 197.195 668.26C139.539 626.53 96.5581 567.635 74.3997 499.999H363.066C389.982 500.168 415.895 489.801 435.267 471.114C454.639 452.427 465.933 426.904 466.733 399.999V66.6661C547.902 84.291 619.691 131.299 668.297 198.653C716.903 266.006 738.895 348.951 730.045 431.538C721.195 514.126 682.127 590.527 620.353 646.052C558.579 701.577 478.46 732.307 395.4 732.333Z"
      fill="white"
      strokeWidth="55"
    />
  </svg>
);

export const GreenCheckIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M100 154.194L130.769 184.75L200 116"
      stroke="#12B740"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="10" y="10" width="280" height="280" rx="140" stroke="#12B740" strokeWidth="20" />
  </svg>
);

export const GreenCheckSolidIcon: SVGComponent = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.8566 8.19113C14.1002 7.85614 14.0261 7.38708 13.6911 7.14345C13.3561 6.89982 12.8871 6.97388 12.6434 7.30887L9.15969 12.099L7.28033 10.2197C6.98744 9.92678 6.51256 9.92678 6.21967 10.2197C5.92678 10.5126 5.92678 10.9874 6.21967 11.2803L8.71967 13.7803C8.87477 13.9354 9.08999 14.0149 9.30867 13.9977C9.52734 13.9805 9.72754 13.8685 9.85655 13.6911L13.8566 8.19113Z"
      fill="#10B981"
    />
  </svg>
);

export const RedCheckIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M200 100L100 200M100 100L200 200"
      stroke="#EB4242"
      strokeWidth="20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="10" y="10" width="280" height="280" rx="140" stroke="#EB4242" strokeWidth="20" />
  </svg>
);

export const GrayCloseSolidIcon: SVGComponent = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.28033 7.21967C7.98744 6.92678 7.51256 6.92678 7.21967 7.21967C6.92678 7.51256 6.92678 7.98744 7.21967 8.28033L8.93934 10L7.21967 11.7197C6.92678 12.0126 6.92678 12.4874 7.21967 12.7803C7.51256 13.0732 7.98744 13.0732 8.28033 12.7803L10 11.0607L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L11.0607 10L12.7803 8.28033C13.0732 7.98744 13.0732 7.51256 12.7803 7.21967C12.4874 6.92678 12.0126 6.92678 11.7197 7.21967L10 8.93934L8.28033 7.21967Z"
      fill="#EB4242"
    />
  </svg>
);

export const HaveQuestionMarkIcon: SVGComponent = (props) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18Z"
      stroke="#EFF0F0"
    />
    <path
      d="M19.2741 14.8301C18.5806 14.2233 17.4199 14.2233 16.7264 14.8301C16.4146 15.1029 15.9408 15.0713 15.668 14.7596C15.3953 14.4479 15.4269 13.974 15.7386 13.7013C16.9977 12.5996 19.0028 12.5996 20.2619 13.7013C21.5797 14.8544 21.5797 16.7706 20.2619 17.9237C20.0392 18.1186 19.7942 18.278 19.5362 18.4028C18.9842 18.67 18.7502 19.0102 18.7502 19.25V19.875C18.7502 20.2892 18.4145 20.625 18.0002 20.625C17.586 20.625 17.2502 20.2892 17.2502 19.875V19.25C17.2502 18.109 18.192 17.387 18.8828 17.0526C19.0254 16.9836 19.157 16.8974 19.2741 16.7949C19.909 16.2394 19.909 15.3856 19.2741 14.8301Z"
      fill="#666D74"
    />
    <path
      d="M17.2501 22.375C17.2501 21.9608 17.5858 21.625 18.0001 21.625H18.0063C18.4205 21.625 18.7563 21.9608 18.7563 22.375V22.3812C18.7563 22.7955 18.4205 23.1312 18.0063 23.1312H18.0001C17.5858 23.1312 17.2501 22.7955 17.2501 22.3812V22.375Z"
      fill="#666D74"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75006 18C9.75006 13.4437 13.4437 9.75 18.0001 9.75C22.5564 9.75 26.2501 13.4437 26.2501 18C26.2501 22.5563 22.5564 26.25 18.0001 26.25C13.4437 26.25 9.75006 22.5563 9.75006 18ZM18.0001 11.25C14.2721 11.25 11.2501 14.2721 11.2501 18C11.2501 21.7279 14.2721 24.75 18.0001 24.75C21.728 24.75 24.7501 21.7279 24.7501 18C24.7501 14.2721 21.728 11.25 18.0001 11.25Z"
      fill="#666D74"
    />
  </svg>
);

export const ThreeDotsIcon: SVGComponent = (props) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoogleIcon: SVGComponent = (props) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30.0014 16.3109C30.0014 15.1598 29.9061 14.3198 29.6998 13.4487H16.2871V18.6442H24.1601C24.0014 19.9354 23.1442 21.8798 21.2394 23.1864L21.2127 23.3604L25.4536 26.58L25.7474 26.6087C28.4458 24.1665 30.0014 20.5731 30.0014 16.3109Z"
      fill="#4285F4"
    />
    <path
      d="M16.2863 29.9998C20.1434 29.9998 23.3814 28.7553 25.7466 26.6086L21.2386 23.1863C20.0323 24.0108 18.4132 24.5863 16.2863 24.5863C12.5086 24.5863 9.30225 22.1441 8.15929 18.7686L7.99176 18.7825L3.58208 22.127L3.52441 22.2841C5.87359 26.8574 10.699 29.9998 16.2863 29.9998Z"
      fill="#34A853"
    />
    <path
      d="M8.15964 18.769C7.85806 17.8979 7.68352 16.9645 7.68352 16.0001C7.68352 15.0356 7.85806 14.1023 8.14377 13.2312L8.13578 13.0456L3.67083 9.64746L3.52475 9.71556C2.55654 11.6134 2.00098 13.7445 2.00098 16.0001C2.00098 18.2556 2.55654 20.3867 3.52475 22.2845L8.15964 18.769Z"
      fill="#FBBC05"
    />
    <path
      d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
      fill="#EB4335"
    />
  </svg>
);

export const DownArrowIcon: SVGComponent = (props) => (
  <svg
    width="441"
    height="240"
    viewBox="0 0 441 240"
    fill="#4b5563"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M430.764 229.644C443.78 216.627 443.78 195.521 430.764 182.504L267.69 19.5892C241.65 -6.42414 199.457 -6.41382 173.43 19.6122L10.4193 182.624C-2.59808 195.641 -2.59808 216.747 10.4193 229.764C23.4369 242.784 44.5422 242.784 57.5599 229.764L197.08 90.2438C210.1 77.2272 231.204 77.2272 244.22 90.2438L383.624 229.644C396.64 242.661 417.747 242.661 430.764 229.644Z"
      fill="#4b5563"
    />
  </svg>
);

export const BillingARIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.07588 2.57576C3.3102 2.34145 3.6901 2.34145 3.92441 2.57576L8.92441 7.57576C9.03693 7.68828 9.10015 7.84089 9.10015 8.00002C9.10015 8.15915 9.03693 8.31177 8.92441 8.42429L3.92441 13.4243C3.6901 13.6586 3.3102 13.6586 3.07588 13.4243C2.84157 13.19 2.84157 12.8101 3.07588 12.5758L7.65162 8.00002L3.07588 3.42429C2.84157 3.18997 2.84157 2.81007 3.07588 2.57576Z"
      fill="#585C62"
    />
    <path
      d="M7.07588 2.57576C7.3102 2.34145 7.6901 2.34145 7.92441 2.57576L12.9244 7.57576C13.0369 7.68828 13.1001 7.8409 13.1001 8.00002C13.1001 8.15915 13.0369 8.31177 12.9244 8.42429L7.92441 13.4243C7.6901 13.6586 7.3102 13.6586 7.07588 13.4243C6.84157 13.19 6.84157 12.8101 7.07588 12.5758L11.6516 8.00002L7.07588 3.42429C6.84157 3.18997 6.84157 2.81008 7.07588 2.57576Z"
      fill="#585C62"
    />
  </svg>
);

export const SingleViewHomeIcon: SVGComponent = (props) => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.5051 6.29528L8.29246 1.63498C8.17564 1.54736 8.03355 1.5 7.88751 1.5C7.74148 1.5 7.59939 1.54736 7.48256 1.63498L1.26997 6.29528C1.18614 6.35814 1.11811 6.43966 1.07125 6.53338C1.02439 6.62709 1 6.73043 1 6.83521V15.8251C1 16.0041 1.07111 16.1757 1.19768 16.3023C1.32425 16.4289 1.49592 16.5 1.67492 16.5H5.52531C5.70431 16.5 5.87598 16.4289 6.00255 16.3023C6.12912 16.1757 6.20023 16.0041 6.20023 15.8251V12.9736C6.20023 12.7946 6.27133 12.6229 6.3979 12.4963C6.52447 12.3698 6.69614 12.2986 6.87514 12.2986H9.23735C9.41634 12.2986 9.58801 12.3698 9.71458 12.4963C9.84115 12.6229 9.91226 12.7946 9.91226 12.9736V15.8251C9.91226 16.0041 9.98337 16.1757 10.1099 16.3023C10.2365 16.4289 10.4082 16.5 10.5872 16.5H14.1001C14.2791 16.5 14.4508 16.4289 14.5773 16.3023C14.7039 16.1757 14.775 16.0041 14.775 15.8251V6.83521C14.775 6.73043 14.7506 6.62709 14.7038 6.53338C14.6569 6.43966 14.5889 6.35814 14.5051 6.29528Z"
      stroke="#585C62"
      strokeWidth="1.5"
    />
  </svg>
);

export const PracticeIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40015 7.00002C5.40015 5.56408 6.56421 4.40002 8.00015 4.40002C9.43609 4.40002 10.6001 5.56408 10.6001 7.00002C10.6001 8.43597 9.43609 9.60002 8.00015 9.60002C6.56421 9.60002 5.40015 8.43597 5.40015 7.00002ZM8.00015 5.60002C7.22695 5.60002 6.60015 6.22683 6.60015 7.00002C6.60015 7.77322 7.22695 8.40002 8.00015 8.40002C8.77335 8.40002 9.40015 7.77322 9.40015 7.00002C9.40015 6.22683 8.77335 5.60002 8.00015 5.60002Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00015 14.5C7.71192 15.0263 7.71171 15.0261 7.71148 15.026L7.70949 15.0249L7.70525 15.0226L7.69142 15.0148C7.67986 15.0083 7.66368 14.9991 7.64317 14.9872C7.60218 14.9635 7.54386 14.929 7.47071 14.884C7.32449 14.7939 7.11852 14.6614 6.87271 14.4878C6.38208 14.1412 5.72735 13.6269 5.07091 12.9548C3.76561 11.6183 2.40015 9.60081 2.40015 7.00002C2.40015 3.90723 4.90735 1.40002 8.00015 1.40002C11.0929 1.40002 13.6001 3.90723 13.6001 7.00002C13.6001 9.60081 12.2347 11.6183 10.9294 12.9548C10.2729 13.6269 9.61822 14.1412 9.12758 14.4878C8.88177 14.6614 8.67581 14.7939 8.52958 14.884C8.45643 14.929 8.39812 14.9635 8.35712 14.9872C8.33662 14.9991 8.32043 15.0083 8.30887 15.0148L8.29504 15.0226L8.2908 15.0249L8.28936 15.0257C8.28913 15.0258 8.28837 15.0263 8.00015 14.5ZM8.00015 2.60002C5.57009 2.60002 3.60015 4.56997 3.60015 7.00002C3.60015 9.16066 4.73469 10.8931 5.92938 12.1163C6.52294 12.724 7.11822 13.192 7.56509 13.5077C7.73525 13.6279 7.88311 13.7255 8.00015 13.7998C8.11718 13.7255 8.26505 13.6279 8.43521 13.5077C8.88208 13.192 9.47735 12.724 10.0709 12.1163C11.2656 10.8931 12.4001 9.16066 12.4001 7.00002C12.4001 4.56997 10.4302 2.60002 8.00015 2.60002Z"
      fill="#585C62"
    />
    <path
      d="M8.00015 14.5L8.28837 15.0263C8.10881 15.1246 7.89105 15.1244 7.71148 15.026L8.00015 14.5Z"
      fill="#585C62"
    />
  </svg>
);

export const PatientIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.89988 3.9999C4.89988 2.28782 6.2878 0.899902 7.99988 0.899902C9.71196 0.899902 11.0999 2.28782 11.0999 3.9999C11.0999 5.71199 9.71196 7.0999 7.99988 7.0999C6.2878 7.0999 4.89988 5.71199 4.89988 3.9999ZM7.99988 2.0999C6.95054 2.0999 6.09988 2.95056 6.09988 3.9999C6.09988 5.04924 6.95054 5.8999 7.99988 5.8999C9.04922 5.8999 9.89988 5.04924 9.89988 3.9999C9.89988 2.95056 9.04922 2.0999 7.99988 2.0999Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40072 13.4017C2.45322 10.3541 4.93988 7.8999 7.99988 7.8999C11.0599 7.8999 13.5467 10.3542 13.599 13.402C13.6031 13.6402 13.4659 13.8582 13.2494 13.9576C11.6506 14.6912 9.87224 15.0999 8.00009 15.0999C6.12777 15.0999 4.34928 14.6911 2.75038 13.9574C2.53385 13.858 2.39662 13.6399 2.40072 13.4017ZM3.62464 13.0302C4.97124 13.5904 6.44884 13.8999 8.00009 13.8999C9.55119 13.8999 11.0286 13.5905 12.3751 13.0304C12.1408 10.8212 10.2713 9.0999 7.99988 9.0999C5.7285 9.0999 3.85901 10.8211 3.62464 13.0302Z"
      fill="#585C62"
    />
  </svg>
);

export const AutoCollectionIcon: SVGComponent = (props) => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.999947 4.55556H15.2222M15.2222 4.55556L11.6666 1M15.2222 4.55556L11.6666 8.11111M0.999947 13.4444H10.7777M10.7777 13.4444L7.22217 9.88889M10.7777 13.4444L7.22217 17"
      stroke="#585C62"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const OutreachIcon: SVGComponent = (props) => (
//   <svg
//     width="860"
//     height="683"
//     viewBox="0 0 860 683"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}>
//     <path
//       d="M207.777 385.552C207.777 301.747 207.777 259.845 233.813 233.809C259.847 207.773 301.75 207.773 385.556 207.773H518.889H652.223C736.027 207.773 777.93 207.773 803.965 233.809C830.001 259.845 830.001 301.747 830.001 385.552V429.996V474.441C830.001 558.245 830.001 600.148 803.965 626.183C777.93 652.219 736.027 652.219 652.223 652.219H518.889H385.556C301.75 652.219 259.847 652.219 233.813 626.183C207.777 600.148 207.777 558.245 207.777 474.441V429.996V385.552Z"
//       stroke="white"
//       strokeWidth="60"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M207.778 474.445C123.973 474.445 82.0699 474.445 56.0352 448.41C30 422.374 30 380.472 30 296.667V207.778C30 123.973 30 82.0699 56.0352 56.0352C82.0699 30 123.973 30 207.778 30H474.445C558.25 30 600.152 30 626.188 56.0352C652.224 82.0699 652.224 123.973 652.224 207.778"
//       stroke="white"
//       strokeWidth="60"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M607.778 429.998C607.778 479.092 567.983 518.888 518.889 518.888C469.796 518.888 430 479.092 430 429.998C430 380.905 469.796 341.109 518.889 341.109C567.983 341.109 607.778 380.905 607.778 429.998Z"
//       stroke="white"
//       strokeWidth="66.6667"
//     />
//   </svg>
// );

export const ChargeIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.5756 1.57564C10.81 1.34132 11.1899 1.34132 11.4242 1.57564L14.4242 4.57564C14.5367 4.68816 14.5999 4.84077 14.5999 4.9999C14.5999 5.15903 14.5367 5.31164 14.4242 5.42417L11.4242 8.42417C11.1899 8.65848 10.81 8.65848 10.5756 8.42417C10.3413 8.18985 10.3413 7.80995 10.5756 7.57564L12.5514 5.5999L4.9999 5.5999C4.66853 5.5999 4.3999 5.33127 4.3999 4.9999C4.3999 4.66853 4.66853 4.3999 4.9999 4.3999L12.5514 4.3999L10.5756 2.42417C10.3413 2.18985 10.3413 1.80995 10.5756 1.57564Z"
      fill="#585C62"
    />
    <path
      d="M5.42417 7.57564C5.65848 7.80995 5.65848 8.18985 5.42417 8.42417L3.44843 10.3999H10.9999C11.3313 10.3999 11.5999 10.6685 11.5999 10.9999C11.5999 11.3313 11.3313 11.5999 10.9999 11.5999H3.44843L5.42417 13.5756C5.65848 13.81 5.65848 14.1899 5.42417 14.4242C5.18985 14.6585 4.80995 14.6585 4.57564 14.4242L1.57564 11.4242C1.34132 11.1899 1.34132 10.81 1.57564 10.5756L4.57564 7.57564C4.80995 7.34132 5.18985 7.34132 5.42417 7.57564Z"
      fill="#585C62"
    />
  </svg>
);

export const ClaimIcon: SVGComponent = (props) => (
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2325 2.66138e-05C3.26453 3.9947e-05 3.29704 5.3237e-05 3.33003 5.3237e-05H9.67C9.70294 5.3237e-05 9.73547 3.9947e-05 9.76753 2.66138e-05C10.4453 -0.000266717 10.9118 -0.000473425 11.3047 0.136232C12.0467 0.394404 12.6227 0.9915 12.8697 1.74371C13.0004 2.14179 13.0002 2.61501 13 3.31768C13 3.34912 13 3.38103 13 3.4134V12.7494C13 13.7262 11.8487 14.3078 11.0904 13.6139C11.0374 13.5654 10.9626 13.5654 10.9096 13.6139L10.5875 13.9086C9.96873 14.4748 9.03121 14.4748 8.41248 13.9086C8.17581 13.692 7.82421 13.692 7.58755 13.9086C6.96875 14.4748 6.03123 14.4748 5.4125 13.9086C5.17583 13.692 4.82422 13.692 4.58756 13.9086C3.96877 14.4748 3.03127 14.4748 2.41249 13.9086L2.09043 13.6139C2.03744 13.5654 1.96262 13.5654 1.90964 13.6139C1.15136 14.3078 4.8542e-05 13.7262 4.8542e-05 12.7494V3.4134C4.8542e-05 3.38103 3.51725e-05 3.34912 2.18393e-05 3.31768C-0.000231492 2.61501 -0.000404805 2.14179 0.130301 1.74371C0.377273 0.9915 0.953342 0.394404 1.69531 0.136232C2.08819 -0.000473425 2.55467 -0.000266717 3.2325 2.66138e-05ZM3.33003 1.00005C2.51598 1.00005 2.23559 1.00704 2.02394 1.08068C1.58436 1.23364 1.23279 1.59151 1.08039 2.05565C1.00633 2.2812 1.00004 2.57862 1.00004 3.4134V12.7494C1.00004 12.8288 1.03999 12.8773 1.09011 12.9005C1.11622 12.9126 1.14175 12.9157 1.16303 12.9128C1.18179 12.9103 1.20607 12.9022 1.23456 12.8762C1.66968 12.478 2.33039 12.478 2.7655 12.8762L3.08757 13.1709C3.32423 13.3874 3.67582 13.3874 3.91247 13.1709C4.53126 12.6046 5.46876 12.6046 6.08756 13.1709C6.32422 13.3874 6.67582 13.3874 6.91249 13.1709C7.53122 12.6046 8.46874 12.6046 9.08754 13.1709C9.3242 13.3874 9.6758 13.3874 9.91247 13.1709L10.2345 12.8762C10.6696 12.478 11.3303 12.478 11.7655 12.8762C11.7939 12.9022 11.8182 12.9103 11.837 12.9128C11.8583 12.9157 11.8838 12.9126 11.9099 12.9005C11.96 12.8773 12 12.8288 12 12.7494V3.4134C12 2.57863 11.9937 2.2812 11.9196 2.05565C11.7672 1.59151 11.4157 1.23364 10.9761 1.08068C10.7644 1.00704 10.484 1.00005 9.67 1.00005H3.33003ZM8.49968 4.12706C8.70568 4.31097 8.72354 4.62705 8.53961 4.83303L6.15869 7.49968C6.06383 7.60595 5.92816 7.66668 5.7857 7.66668C5.6433 7.66668 5.50763 7.60595 5.41276 7.49968L4.46038 6.43302C4.27647 6.22702 4.29436 5.91096 4.50034 5.72705C4.70632 5.54313 5.0224 5.56102 5.2063 5.76701L5.7857 6.41595L7.79368 4.16702C7.97761 3.96103 8.29368 3.94315 8.49968 4.12706ZM3.00003 9.5C3.00003 9.22387 3.22388 9 3.50002 9H9.5C9.77613 9 10 9.22387 10 9.5C10 9.77613 9.77613 10 9.5 10H3.50002C3.22388 10 3.00003 9.77613 3.00003 9.5Z"
      fill="#585C62"
    />
  </svg>
);

export const GroupClaimIcon: SVGComponent = (props) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4.72848 16.1369C3.18295 14.5914 2.41018 13.8186 2.12264 12.816C1.83509 11.8134 2.08083 10.7485 2.57231 8.61875L2.85574 7.39057C3.26922 5.59881 3.47597 4.70292 4.08944 4.08944C4.70292 3.47597 5.5988 3.26922 7.39057 2.85574L8.61875 2.57231C10.7485 2.08083 11.8134 1.83509 12.816 2.12264C13.8186 2.41018 14.5914 3.18295 16.1369 4.72848L17.9665 6.55812C20.6555 9.24711 22 10.5916 22 12.2623C22 13.933 20.6555 15.2775 17.9665 17.9665C15.2775 20.6555 13.933 22 12.2623 22C10.5916 22 9.24711 20.6555 6.55812 17.9665L4.72848 16.1369Z"
      stroke="#585C62"
      strokeWidth="1.5"
    />
    <path
      d="M15.3893 15.3891C15.9751 14.8033 16.0542 13.9327 15.5661 13.4445C15.0779 12.9564 14.2073 13.0355 13.6215 13.6213C13.0358 14.2071 12.1652 14.2863 11.677 13.7981C11.1888 13.3099 11.268 12.4393 11.8538 11.8536M15.3893 15.3891L15.7429 15.7426M15.3893 15.3891C14.9883 15.7901 14.4539 15.9537 14 15.8604M11.5002 11.5L11.8538 11.8536M11.8538 11.8536C12.185 11.5223 12.6073 11.3531 13 11.3568"
      stroke="#585C62"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle
      cx="8.60724"
      cy="8.87891"
      r="2"
      transform="rotate(-45 8.60724 8.87891)"
      stroke="#585C62"
      strokeWidth="1.5"
    />
  </svg>
);

export const OutstandingIcon: SVGComponent = (props) => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1 4.75H9.125C11.8174 4.75 14 6.93261 14 9.625C14 12.3174 11.8174 14.5 9.125 14.5H1M1 4.75L4.25 1.5M1 4.75L4.25 8"
      stroke="#585C62"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkIcon: SVGComponent = (props) => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09625 3.78125C8.09625 3.65693 8.04687 3.5377 7.95896 3.44979C7.87105 3.36189 7.75182 3.3125 7.6275 3.3125H1.40625C1.03329 3.3125 0.675604 3.46066 0.411881 3.72438C0.148158 3.9881 0 4.34579 0 4.71875L0 14.0938C0 14.4667 0.148158 14.8244 0.411881 15.0881C0.675604 15.3519 1.03329 15.5 1.40625 15.5H10.7813C11.1542 15.5 11.5119 15.3519 11.7756 15.0881C12.0393 14.8244 12.1875 14.4667 12.1875 14.0938V7.8725C12.1875 7.74818 12.1381 7.62895 12.0502 7.54105C11.9623 7.45314 11.8431 7.40375 11.7188 7.40375C11.5944 7.40375 11.4752 7.45314 11.3873 7.54105C11.2994 7.62895 11.25 7.74818 11.25 7.8725V14.0938C11.25 14.2181 11.2006 14.3373 11.1127 14.4252C11.0248 14.5131 10.9056 14.5625 10.7813 14.5625H1.40625C1.28193 14.5625 1.1627 14.5131 1.07479 14.4252C0.986886 14.3373 0.9375 14.2181 0.9375 14.0938V4.71875C0.9375 4.59443 0.986886 4.4752 1.07479 4.38729C1.1627 4.29939 1.28193 4.25 1.40625 4.25H7.6275C7.75182 4.25 7.87105 4.20061 7.95896 4.11271C8.04687 4.0248 8.09625 3.90557 8.09625 3.78125Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9996 0.96875C14.9996 0.84443 14.9502 0.725202 14.8623 0.637294C14.7744 0.549386 14.6552 0.5 14.5309 0.5H9.84337C9.71905 0.5 9.59982 0.549386 9.51191 0.637294C9.424 0.725202 9.37462 0.84443 9.37462 0.96875C9.37462 1.09307 9.424 1.2123 9.51191 1.30021C9.59982 1.38811 9.71905 1.4375 9.84337 1.4375H13.3993L5.76149 9.07438C5.71791 9.11797 5.68334 9.16971 5.65975 9.22665C5.63616 9.28359 5.62402 9.34462 5.62402 9.40626C5.62402 9.46789 5.63616 9.52893 5.65975 9.58587C5.68334 9.64281 5.71791 9.69455 5.76149 9.73813C5.80507 9.78172 5.85681 9.81629 5.91376 9.83987C5.9707 9.86346 6.03173 9.8756 6.09337 9.8756C6.155 9.8756 6.21603 9.86346 6.27298 9.83987C6.32992 9.81629 6.38166 9.78172 6.42524 9.73813L14.0621 2.10031V5.65625C14.0621 5.78058 14.1115 5.8998 14.1994 5.98771C14.2873 6.07562 14.4065 6.12501 14.5309 6.12501C14.6552 6.12501 14.7744 6.07562 14.8623 5.98771C14.9502 5.8998 14.9996 5.78058 14.9996 5.65625V0.96875Z"
      fill="#585C62"
    />
  </svg>
);

export const VisitIcon: SVGComponent = (props) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="30" height="30" rx="2" fill="#0E85DC" fillOpacity="0.2" />
    <path
      d="M22.5 11.7187C22.5 9.375 21.5625 7.5 19.6875 7.5C18.8022 7.5 18.2304 7.70898 17.6268 7.92961C16.9519 8.17627 16.2372 8.4375 15 8.4375C13.7628 8.4375 13.0481 8.17627 12.3732 7.92961C11.7695 7.70898 11.1978 7.5 10.3125 7.5C8.4375 7.5 7.5 9.375 7.5 11.7187C7.5 13.2173 7.8833 14.1411 8.28226 15.1025C8.50725 15.6447 8.73723 16.1989 8.90625 16.875C8.97219 17.1388 9.01959 17.4582 9.05756 17.8125M21.7177 15.1025C21.4927 15.6447 21.2628 16.1989 21.0938 16.875C20.9541 17.4337 20.8976 18.2422 20.8376 19.102C20.6963 21.1275 20.535 23.4375 19.2188 23.4375C18.3759 23.4375 18.0068 22.1116 17.6002 20.6517C17.1023 18.8638 16.5484 16.875 15 16.875C13.4517 16.875 12.8978 18.8638 12.3999 20.6517C11.9933 22.1116 11.6241 23.4375 10.7813 23.4375C10.0058 23.4375 9.6312 22.6356 9.42541 21.5625"
      stroke="#0E85DC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 11.7187C22.5 9.375 21.5625 7.5 19.6875 7.5C18.8022 7.5 18.2304 7.70898 17.6268 7.92961C16.9519 8.17627 16.2372 8.4375 15 8.4375C13.7628 8.4375 13.0481 8.17627 12.3732 7.92961C11.7695 7.70898 11.1978 7.5 10.3125 7.5C8.4375 7.5 7.5 9.375 7.5 11.7187C7.5 13.2173 7.8833 14.1411 8.28226 15.1025C8.50725 15.6447 8.73723 16.1989 8.90625 16.875C8.97219 17.1388 9.01959 17.4582 9.05756 17.8125M21.7177 15.1025C21.4927 15.6447 21.2628 16.1989 21.0938 16.875C20.9541 17.4337 20.8976 18.2422 20.8376 19.102C20.6963 21.1275 20.535 23.4375 19.2188 23.4375C18.3759 23.4375 18.0068 22.1116 17.6002 20.6517C17.1023 18.8638 16.5484 16.875 15 16.875C13.4517 16.875 12.8978 18.8638 12.3999 20.6517C11.9933 22.1116 11.6241 23.4375 10.7813 23.4375C10.0058 23.4375 9.6312 22.6356 9.42541 21.5625"
      stroke="#0E85DC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaymentIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="16" height="16" rx="1.5" fill="#11A320" fillOpacity="0.2" />
    <path
      d="M11.112 10.4997C10.9482 10.807 10.7229 11.0633 10.4379 11.2733C10.1517 11.4827 9.80924 11.6386 9.41129 11.7414C9.23734 11.7854 9.05515 11.8159 8.87021 11.8409V13H7.48685V11.8641C7.09287 11.8309 6.71629 11.7695 6.36168 11.6719C5.82029 11.5236 5.11137 10.9248 5.11137 10.9248C5.05064 10.8894 5.01035 10.8271 5.00181 10.7582C4.99297 10.6886 5.01678 10.6184 5.06652 10.569L5.75957 9.87561C5.83433 9.80176 5.95031 9.78771 6.04002 9.84264C6.04002 9.84264 6.55883 10.2931 6.95189 10.4005C7.34496 10.5073 7.73498 10.561 8.12408 10.561C8.6148 10.561 9.02039 10.4744 9.34203 10.301C9.6643 10.1264 9.82482 9.85668 9.82482 9.48803C9.82482 9.22252 9.74609 9.01316 9.58709 8.85936C9.42871 8.70676 9.16076 8.61064 8.78264 8.56852L7.54117 8.4617C6.80599 8.38998 6.23898 8.1849 5.84072 7.84891C5.44125 7.51168 5.24289 7.00021 5.24289 6.31662C5.24289 5.9382 5.31918 5.60129 5.47269 5.30496C5.6265 5.00863 5.83525 4.7584 6.10105 4.55453C6.36656 4.35006 6.67601 4.19686 7.02818 4.09494C7.17558 4.05221 7.33 4.02414 7.48685 3.9985V3H8.87021V3.9784C9.19308 4.01014 9.50041 4.06201 9.78635 4.14076C10.2716 4.2732 10.7812 4.67178 10.7812 4.67178C10.845 4.70475 10.8883 4.76699 10.8993 4.83779C10.9103 4.90982 10.8868 4.98063 10.8365 5.0325L10.1864 5.69229C10.1172 5.76248 10.0101 5.78078 9.92154 5.73502C9.92154 5.73502 9.53672 5.46098 9.20408 5.3743C8.87174 5.28762 8.52262 5.24367 8.15488 5.24367C7.67424 5.24367 7.319 5.33584 7.08982 5.51924C6.85973 5.70387 6.74558 5.94373 6.74558 6.23945C6.74558 6.50588 6.82584 6.70973 6.99033 6.85193C7.15359 6.99537 7.42918 7.08844 7.81765 7.12781L8.9056 7.22059C9.71219 7.29199 10.3229 7.50623 10.7363 7.86359C11.1505 8.22156 11.3571 8.74281 11.3571 9.42641C11.3571 9.83625 11.2753 10.193 11.112 10.4997Z"
      fill="#11A320"
    />
  </svg>
);

export const ViewIcon: SVGComponent = (props) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.99984 0C2.23879 0 0 2.23863 0 4.99984C0 7.76106 2.23879 9.99969 4.99984 9.99969C7.76154 9.99969 10 7.76108 10 4.99984C10 2.23861 7.76154 0 4.99984 0ZM5.87777 7.29531C5.67553 7.51977 5.55961 7.65316 5.34131 7.86186C5.01088 8.17781 4.63568 8.26193 4.34398 7.95006C3.92471 7.50164 4.36445 6.13748 4.37518 6.08582C4.45393 5.72324 4.61111 4.99857 4.61111 4.99857C4.61111 4.99857 4.27152 5.20647 4.06992 5.2802C3.92123 5.33453 3.75303 5.26318 3.71145 5.11938C3.6727 4.98613 3.70355 4.90139 3.78516 4.81035C3.98738 4.58606 4.1033 4.45266 4.32162 4.24397C4.65236 3.92785 5.02725 3.84391 5.31894 4.15561C5.73822 4.60402 5.42887 5.34178 5.3202 5.86453C5.30949 5.91635 5.0518 7.10725 5.0518 7.10725C5.0518 7.10725 5.39139 6.89934 5.59299 6.82547C5.74197 6.77129 5.91019 6.84279 5.95178 6.98645C5.99055 7.11971 5.95937 7.20443 5.87777 7.29531ZM5.33533 3.43975C4.86881 3.48068 4.45772 3.13576 4.41676 2.66891C4.37613 2.20254 4.72106 1.79129 5.1876 1.75066C5.65381 1.70971 6.06521 2.05496 6.10586 2.52133C6.1468 2.98772 5.80154 3.39912 5.33533 3.43975Z"
      fill="#0E85DC"
    />
  </svg>
);

export const WarningIcon: SVGComponent = (props) => (
  <svg
    width="704"
    height="633"
    viewBox="0 0 704 633"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M384.864 8.7952C395.199 14.7012 403.765 23.2667 409.671 33.6021L694.792 532.565C713.06 564.532 701.953 605.256 669.985 623.523C659.912 629.279 648.511 632.307 636.909 632.307H66.6667C29.8477 632.307 0 602.459 0 565.641C0 554.039 3.02769 542.638 8.78379 532.565L293.905 33.6021C312.172 1.63432 352.896 -9.47213 384.864 8.7952ZM350 425C326.19 425 308.333 442.6 308.333 466.067C308.333 490.6 325.649 508.2 350 508.2C373.81 508.2 391.667 490.6 391.667 466.6C391.667 442.6 373.81 425 350 425ZM383.333 166.667H316.667V366.667H383.333V166.667Z"
      fill="#FFD600"
    />
  </svg>
);

export const SuccessIcon: SVGComponent = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mb-2"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1693 1.97134C13.0467 -0.657115 16.9532 -0.657115 18.8307 1.97134L19.1297 2.3898C19.46 2.8524 20.0148 3.10009 20.5798 3.03733L21.912 2.88929C24.9104 2.55615 27.4439 5.08962 27.1107 8.08794L26.9628 9.42022C26.9 9.9852 27.1476 10.54 27.6102 10.8704L28.0287 11.1693C30.6571 13.0467 30.6571 16.9532 28.0287 18.8307L27.6102 19.1297C27.1476 19.46 26.9 20.0148 26.9628 20.5798L27.1107 21.912C27.4439 24.9104 24.9104 27.4439 21.912 27.1107L20.5798 26.9628C20.0148 26.9 19.46 27.1476 19.1297 27.6102L18.8307 28.0287C16.9532 30.6571 13.0469 30.6571 11.1693 28.0287L10.8704 27.6102C10.54 27.1476 9.9852 26.9 9.4202 26.9628L8.08794 27.1107C5.08962 27.4439 2.55615 24.9104 2.88929 21.912L3.03733 20.5798C3.10009 20.0148 2.8524 19.46 2.3898 19.1297L1.97134 18.8307C-0.657115 16.9532 -0.657115 13.0469 1.97134 11.1693L2.3898 10.8704C2.8524 10.54 3.10009 9.9852 3.03733 9.4202L2.88929 8.08794C2.55615 5.08962 5.08962 2.55615 8.08794 2.88929L9.42022 3.03733C9.9852 3.10009 10.54 2.8524 10.8704 2.3898L11.1693 1.97134ZM20.8172 10.752C21.4299 11.3649 21.4299 12.3584 20.8172 12.9712L14.8246 18.9638C14.0549 19.7336 12.8068 19.7336 12.0371 18.9638L9.18286 16.1096C8.57006 15.4968 8.57006 14.5032 9.18286 13.8904C9.79568 13.2777 10.7892 13.2777 11.402 13.8904L13.4308 15.9193L18.598 10.752C19.2108 10.1392 20.2044 10.1392 20.8172 10.752Z"
      fill="#01C338"
    />
  </svg>
);

export const PlayIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 650 650" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M297.03 189.206C256.863 165.491 211.629 197.74 211.629 240.746V409.252C211.629 452.258 256.863 484.507 297.03 460.792L439.734 376.54C478.229 353.811 478.229 296.188 439.734 273.459L297.03 189.206ZM256.978 240.746C256.978 234.746 259.885 230.549 263.311 228.406C266.625 226.333 270.337 226.108 273.974 228.256L416.678 312.511C420.687 314.878 423.257 319.401 423.257 325C423.257 330.599 420.687 335.122 416.678 337.489L273.974 421.744C270.337 423.89 266.625 423.667 263.311 421.593C259.885 419.452 256.978 415.253 256.978 409.252V240.746Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M325 0C145.507 0 0 145.507 0 325C0 504.494 145.507 650 325 650C504.494 650 650 504.494 650 325C650 145.507 504.494 0 325 0ZM45.3488 325C45.3488 170.553 170.553 45.3488 325 45.3488C479.446 45.3488 604.651 170.553 604.651 325C604.651 479.446 479.446 604.651 325 604.651C170.553 604.651 45.3488 479.446 45.3488 325Z"
      fill="white"
    />
  </svg>
);

export const StopIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 650 650" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M258.333 225V425M391.667 225V425M325 625C490.687 625 625 490.687 625 325C625 159.315 490.687 25 325 25C159.315 25 25 159.315 25 325C25 490.687 159.315 625 325 625Z"
      stroke="white"
      strokeWidth="50"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnblockIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 809 670" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M35 173.462H542.692C628.963 173.462 672.103 173.462 704.231 192.012C725.282 204.164 742.76 221.643 754.912 242.692C773.462 274.822 773.462 317.96 773.462 404.231C773.462 490.502 773.462 533.637 754.912 565.769C742.76 586.82 725.282 604.298 704.231 616.451C672.103 635 628.963 635 542.692 635H219.616M35 173.462L173.462 35M35 173.462L173.462 311.923"
      stroke="white"
      strokeWidth="70"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlockOutreachIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 737 737" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M604.04 132.632C664.359 192.953 701.67 276.287 701.67 368.335C701.67 552.432 552.432 701.67 368.335 701.67C276.287 701.67 192.953 664.359 132.632 604.04M604.04 132.632C543.717 72.3098 460.384 35 368.335 35C184.239 35 35 184.239 35 368.335C35 460.384 72.3098 543.717 132.632 604.04M604.04 132.632L132.632 604.04"
      stroke="white"
      strokeWidth="70"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoneyIcon: SVGComponent = (props) => (
  <svg
    fill="#000000"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M12.32 8a3 3 0 0 0-2-.7H5.63A1.59 1.59 0 0 1 4 5.69a2 2 0 0 1 0-.25 1.59 1.59 0 0 1 1.63-1.33h4.62a1.59 1.59 0 0 1 1.57 1.33h1.5a3.08 3.08 0 0 0-3.07-2.83H8.67V.31H7.42v2.3H5.63a3.08 3.08 0 0 0-3.07 2.83 2.09 2.09 0 0 0 0 .25 3.07 3.07 0 0 0 3.07 3.07h4.74A1.59 1.59 0 0 1 12 10.35a1.86 1.86 0 0 1 0 .34 1.59 1.59 0 0 1-1.55 1.24h-4.7a1.59 1.59 0 0 1-1.55-1.24H2.69a3.08 3.08 0 0 0 3.06 2.73h1.67v2.27h1.25v-2.27h1.7a3.08 3.08 0 0 0 3.06-2.73v-.34A3.06 3.06 0 0 0 12.32 8z" />
  </svg>
);

export const MobilePhoneIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.85462 7.28621L4.92241 6.75232C5.31094 6.55805 5.52962 6.13518 5.46357 5.70584L5.02389 2.84794C4.94884 2.36011 4.52909 2 4.03552 2H3C2.44772 2 2 2.44772 2 3V5C2 5.70879 2.08208 6.39936 2.23758 7.06237C3.01505 10.3773 5.62265 12.985 8.93763 13.7624C9.60064 13.9179 10.2912 14 11 14H13C13.5523 14 14 13.5523 14 13V11.9645C14 11.4709 13.6399 11.0512 13.1521 10.9761L10.2942 10.5364C9.86482 10.4704 9.44195 10.6891 9.24768 11.0776L8.71379 12.1454C6.4109 11.4092 4.59083 9.58911 3.85462 7.28621Z"
      fill="#81888F"
    />
  </svg>
);

export const MailIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 3C1.67157 3 1 3.67157 1 4.5V5.29294C1.02568 5.30204 1.05113 5.31264 1.07623 5.32476L7.67411 8.50994C7.88011 8.60939 8.12023 8.60939 8.32623 8.50994L14.9241 5.32476C14.9491 5.31269 14.9744 5.30214 15 5.29306V4.5C15 3.67157 14.3284 3 13.5 3H2.5Z"
      fill="#81888F"
    />
    <path
      d="M15 6.95377L8.97836 9.86077C8.36036 10.1591 7.63999 10.1591 7.02199 9.86077L1 6.9536V11.5C1 12.3284 1.67157 13 2.5 13H13.5C14.3284 13 15 12.3284 15 11.5V6.95377Z"
      fill="#81888F"
    />
  </svg>
);

export const NewGroupIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 667 667" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M566.667 366.667C621.895 366.667 666.667 411.438 666.667 466.667V566.667C666.667 621.895 621.895 666.667 566.667 666.667H466.667C411.438 666.667 366.667 621.895 366.667 566.667V466.667C366.667 411.438 411.438 366.667 466.667 366.667H566.667ZM200 366.667C255.228 366.667 300 411.438 300 466.667V566.667C300 621.895 255.228 666.667 200 666.667H100C44.7715 666.667 0 621.895 0 566.667V466.667C0 411.438 44.7715 366.667 100 366.667H200ZM566.667 433.333H466.667C448.257 433.333 433.333 448.257 433.333 466.667V566.667C433.333 585.076 448.257 600 466.667 600H566.667C585.076 600 600 585.076 600 566.667V466.667C600 448.257 585.076 433.333 566.667 433.333ZM200 433.333H100C81.5905 433.333 66.6667 448.257 66.6667 466.667V566.667C66.6667 585.076 81.5905 600 100 600H200C218.409 600 233.333 585.076 233.333 566.667V466.667C233.333 448.257 218.409 433.333 200 433.333ZM200 0C255.228 0 300 44.7715 300 100V200C300 255.228 255.228 300 200 300H100C44.7715 300 0 255.228 0 200V100C0 44.7715 44.7715 0 100 0H200ZM566.667 0C621.895 0 666.667 44.7715 666.667 100V200C666.667 255.228 621.895 300 566.667 300H466.667C411.438 300 366.667 255.228 366.667 200V100C366.667 44.7715 411.438 0 466.667 0H566.667ZM200 66.6667H100C81.5905 66.6667 66.6667 81.5905 66.6667 100V200C66.6667 218.409 81.5905 233.333 100 233.333H200C218.409 233.333 233.333 218.409 233.333 200V100C233.333 81.5905 218.409 66.6667 200 66.6667ZM566.667 66.6667H466.667C448.257 66.6667 433.333 81.5905 433.333 100V200C433.333 218.409 448.257 233.333 466.667 233.333H566.667C585.076 233.333 600 218.409 600 200V100C600 81.5905 585.076 66.6667 566.667 66.6667Z"
      fill="#8A8D98"
    />
  </svg>
);

export const PaymentMetricsIcon: SVGComponent = (props) => (
  <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0616 0.902621C10.1474 0.582542 10.4764 0.392592 10.7965 0.478357L14.6214 1.50323C14.7751 1.54441 14.9061 1.64497 14.9857 1.78278C15.0653 1.92059 15.0868 2.08437 15.0456 2.23808L14.0208 6.06295C13.935 6.38303 13.606 6.57298 13.2859 6.48721C12.9658 6.40145 12.7759 6.07244 12.8616 5.75236L13.5092 3.33555C11.7043 4.44767 10.2033 5.872 9.03485 7.49772C8.93209 7.64069 8.77173 7.73131 8.59624 7.74557C8.42076 7.75984 8.24786 7.6963 8.12337 7.57181L5.60005 5.04849L1.82431 8.82422C1.59 9.05854 1.2101 9.05854 0.975785 8.82422C0.74147 8.58991 0.74147 8.21001 0.975785 7.9757L5.17578 3.7757C5.4101 3.54138 5.79 3.54138 6.02431 3.7757L8.48319 6.23457C9.68395 4.70436 11.1707 3.36043 12.9194 2.28953L10.4859 1.63747C10.1658 1.5517 9.97588 1.2227 10.0616 0.902621Z"
      fill="#585C62"
    />
  </svg>
);

export const NewInsightsIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.00015 1.60015C5.57009 1.60015 3.60015 3.57009 3.60015 6.00015C3.60015 7.62597 4.48163 9.04661 5.79563 9.809C6.48012 10.2062 7.10015 10.9354 7.10015 11.8724V12.0001C7.10015 12.3315 6.83152 12.6001 6.50015 12.6001C6.16878 12.6001 5.90015 12.3315 5.90015 12.0001V11.8724C5.90015 11.4988 5.64248 11.1075 5.1934 10.8469C3.5246 9.87869 2.40015 8.07108 2.40015 6.00015C2.40015 2.90735 4.90735 0.400146 8.00015 0.400146C11.0929 0.400146 13.6001 2.90735 13.6001 6.00015C13.6001 8.07108 12.4757 9.87869 10.8069 10.8469C10.3578 11.1075 10.1001 11.4988 10.1001 11.8724V12.0001C10.1001 12.3315 9.83152 12.6001 9.50015 12.6001C9.16878 12.6001 8.90015 12.3315 8.90015 12.0001V11.8724C8.90015 10.9354 9.52018 10.2062 10.2047 9.809C11.5187 9.04661 12.4001 7.62597 12.4001 6.00015C12.4001 3.57009 10.4302 1.60015 8.00015 1.60015Z"
      fill="#585C62"
    />
    <path
      d="M6.41908 8.22462C6.50168 7.9037 6.82879 7.71051 7.1497 7.79311C7.42083 7.86289 7.70567 7.90015 8.00015 7.90015C8.29462 7.90015 8.57947 7.86289 8.85059 7.79311C9.1715 7.71051 9.49861 7.9037 9.58121 8.22462C9.66381 8.54553 9.47061 8.87264 9.1497 8.95523C8.97035 9.00139 8.78692 9.03697 8.60015 9.06133V12.0001C8.60015 12.3315 8.33152 12.6001 8.00015 12.6001C7.66878 12.6001 7.40015 12.3315 7.40015 12.0001V9.06133C7.21337 9.03697 7.02994 9.00139 6.85059 8.95523C6.52968 8.87264 6.33649 8.54553 6.41908 8.22462Z"
      fill="#585C62"
    />
    <path
      d="M5.91066 13.2479C5.97242 12.9224 6.2864 12.7085 6.61197 12.7703C7.06117 12.8555 7.52516 12.9002 8.00015 12.9002C8.47513 12.9002 8.93913 12.8555 9.38833 12.7703C9.71389 12.7085 10.0279 12.9224 10.0896 13.2479C10.1514 13.5735 9.93754 13.8875 9.61197 13.9493C9.08942 14.0484 8.55055 14.1002 8.00015 14.1002C7.44974 14.1002 6.91088 14.0484 6.38832 13.9493C6.06276 13.8875 5.8489 13.5735 5.91066 13.2479Z"
      fill="#585C62"
    />
    <path
      d="M6.4034 14.8857C6.43788 14.5561 6.733 14.3169 7.06257 14.3514C7.37051 14.3836 7.6833 14.4001 8.00015 14.4001C8.317 14.4001 8.62978 14.3836 8.93772 14.3514C9.26729 14.3169 9.56241 14.5561 9.59689 14.8857C9.63137 15.2153 9.39215 15.5104 9.06257 15.5449C8.71323 15.5814 8.35877 15.6001 8.00015 15.6001C7.64152 15.6001 7.28706 15.5814 6.93772 15.5449C6.60815 15.5104 6.36893 15.2153 6.4034 14.8857Z"
      fill="#585C62"
    />
  </svg>
);

export const EyeIcon: SVGComponent = (props) => (
  <svg
    width="727"
    height="594"
    viewBox="0 0 727 594"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M263.333 45.3207C293.718 35.656 327.013 30 363.333 30C502.73 30 597.6 113.319 654.17 186.811C682.5 223.618 696.667 242.02 696.667 296.667C696.667 351.313 682.5 369.717 654.17 406.523C597.6 480.013 502.73 563.333 363.333 563.333C223.937 563.333 129.065 480.013 72.4963 406.523C44.1653 369.717 30 351.313 30 296.667C30 242.02 44.1653 223.618 72.4963 186.811C88.5373 165.971 107.658 144.342 130 124.046"
      stroke="white"
      strokeWidth="60"
      strokeLinecap="round"
    />
    <path
      d="M463.334 296.668C463.334 351.898 418.564 396.668 363.334 396.668C308.104 396.668 263.334 351.898 263.334 296.668C263.334 241.438 308.104 196.668 363.334 196.668C418.564 196.668 463.334 241.438 463.334 296.668Z"
      stroke="white"
      strokeWidth="60"
    />
  </svg>
);

export const NewReportIcon: SVGComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 564 718" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M103.794 717.857H459.374C528.683 717.857 563.169 683.036 563.169 613.057V105.134C563.169 35.4914 528.683 0 459.374 0H103.794C34.8214 0 0 35.4914 0 105.134V613.057C0 683.036 34.8214 717.857 103.794 717.857ZM106.473 663.95C71.9857 663.95 53.9057 645.536 53.9057 612.053V106.139C53.9057 72.9914 71.9857 53.9057 106.807 53.9057H456.696C491.517 53.9057 509.263 72.6557 509.263 106.139V612.053C509.263 645.536 491.517 663.95 457.031 663.95H106.473ZM155.021 193.861H408.816C420.536 193.861 429.576 184.487 429.576 172.767C429.576 161.383 420.536 152.679 408.816 152.679H155.021C142.633 152.679 133.927 161.383 133.927 172.767C133.927 184.487 142.633 193.861 155.021 193.861ZM155.021 310.714H408.816C420.536 310.714 429.576 301.339 429.576 289.62C429.576 278.236 420.536 269.531 408.816 269.531H155.021C142.633 269.531 133.927 278.236 133.927 289.62C133.927 301.339 142.633 310.714 155.021 310.714ZM155.021 427.567H275.223C286.941 427.567 295.981 418.526 295.981 407.143C295.981 395.424 286.941 386.383 275.223 386.383H155.021C142.633 386.383 133.927 395.424 133.927 407.143C133.927 418.526 142.633 427.567 155.021 427.567Z"
      fill="white"
    />
  </svg>
);

export const NewUsersIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90015 4.2499C2.90015 2.67589 4.17613 1.3999 5.75015 1.3999C7.32416 1.3999 8.60015 2.67589 8.60015 4.2499C8.60015 5.82391 7.32416 7.0999 5.75015 7.0999C4.17613 7.0999 2.90015 5.82391 2.90015 4.2499ZM5.75015 2.5999C4.83888 2.5999 4.10015 3.33863 4.10015 4.2499C4.10015 5.16117 4.83888 5.8999 5.75015 5.8999C6.66142 5.8999 7.40015 5.16117 7.40015 4.2499C7.40015 3.33863 6.66142 2.5999 5.75015 2.5999Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.40015 5.7499C9.40015 4.45203 10.4523 3.3999 11.7501 3.3999C13.048 3.3999 14.1001 4.45203 14.1001 5.7499C14.1001 7.04777 13.048 8.0999 11.7501 8.0999C10.4523 8.0999 9.40015 7.04777 9.40015 5.7499ZM11.7501 4.5999C11.115 4.5999 10.6001 5.11477 10.6001 5.7499C10.6001 6.38503 11.115 6.8999 11.7501 6.8999C12.3853 6.8999 12.9001 6.38503 12.9001 5.7499C12.9001 5.11477 12.3853 4.5999 11.7501 4.5999Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1727 13.4172C8.87105 14.1695 7.36 14.5999 5.75015 14.5999C4.08375 14.5999 2.52323 14.1388 1.19127 13.3368C1.01407 13.2301 0.904322 13.0397 0.900845 12.8329C0.900381 12.8053 0.900146 12.7776 0.900146 12.7499C0.900146 10.0713 3.07157 7.8999 5.75015 7.8999C7.28698 7.8999 8.65622 8.61487 9.5443 9.72866C10.1332 9.2131 10.905 8.8999 11.7501 8.8999C13.6003 8.8999 15.1001 10.3997 15.1001 12.2499C15.1001 12.2967 15.0992 12.3434 15.0972 12.3898C15.0882 12.6097 14.9595 12.807 14.7619 12.9039C13.8522 13.3498 12.8295 13.5999 11.7501 13.5999C11.2078 13.5999 10.6796 13.5368 10.1727 13.4172ZM2.10997 12.4801C3.19198 13.0667 4.43138 13.3999 5.75015 13.3999C7.06892 13.3999 8.30834 13.0667 9.39035 12.4801C9.3512 11.9431 9.19609 11.4393 8.95024 10.9927C8.32843 9.86312 7.12799 9.0999 5.75015 9.0999C3.82505 9.0999 2.24804 10.5903 2.10997 12.4801ZM10.5775 12.2782C10.9554 12.3579 11.3476 12.3999 11.7501 12.3999C12.506 12.3999 13.226 12.2518 13.8838 11.9833C13.7525 10.9217 12.8473 10.0999 11.7501 10.0999C11.1324 10.0999 10.5753 10.3601 10.1825 10.7784C10.3901 11.2445 10.5263 11.7492 10.5775 12.2782Z"
      fill="#585C62"
    />
  </svg>
);

export const IncreaseGreenIcon: SVGComponent = (props) => (
  <svg fill="#00A171" height="20px" width="20px" viewBox="0 0 490 490" {...props}>
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g>
        {" "}
        <path d="M437.2,178.7c12.8,12.8,12.8,33.4,0,46.2c-6.4,6.4-14.7,9.6-23.1,9.6s-16.7-3.2-23.1-9.6L277.7,111.5v345.8 c0,18-14.6,32.7-32.7,32.7s-32.7-14.6-32.7-32.7V111.5L99,224.9c-12.8,12.8-33.4,12.8-46.2,0s-12.8-33.4,0-46.2L221.9,9.6 C228,3.4,236.3,0,245,0c8.7,0,17,3.4,23.1,9.6L437.2,178.7z" />{" "}
      </g>{" "}
    </g>
  </svg>
);

export const DecreaseIcon: SVGComponent = (props) => (
  <svg viewBox="0 0 600 600" fill="#d10000" {...props} stroke="#d10000">
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          id="path298"
          d="m 573.73418,367.6914 a 42.015938,42.066681 0 0 1 -13.71472,29.12363 l -231.1575,210.27004 a 42.015938,42.066681 0 0 1 -0.0513,0.0349 42.015938,42.066681 0 0 1 -28.2031,11.54637 42.015938,42.066681 0 0 1 -28.199,-11.54432 42.015938,42.066681 0 0 1 -0.0554,-0.037 L 41.195655,396.81503 a 42.015938,42.066681 0 0 1 -2.844323,-59.42387 42.015938,42.066681 0 0 1 59.351082,-2.84809 L 258.59123,480.8943 V 28.622751 a 42.015938,42.066681 0 0 1 42.01633,-42.06633 42.015938,42.066681 0 0 1 42.01632,42.06633 V 480.8943 L 503.51065,334.54307 a 42.015938,42.066681 0 0 1 59.35313,2.84809 42.015938,42.066681 0 0 1 10.8704,30.30024 z"
        />{" "}
      </g>{" "}
    </g>
  </svg>
);

export const GreenShieldCheckIcon: SVGComponent = (props) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.161 0.23701C8.25629 0.157973 8.3762 0.114716 8.5 0.114716C8.6238 0.114716 8.74371 0.157973 8.839 0.23701C10.8366 1.89867 13.3215 2.86376 15.917 2.98601C16.034 2.98961 16.1459 3.03411 16.2335 3.11177C16.321 3.18942 16.3785 3.29532 16.396 3.41101C16.465 3.93101 16.5 4.46101 16.5 5.00101C16.5 10.163 13.24 14.564 8.666 16.257C8.55886 16.2965 8.44114 16.2965 8.334 16.257C3.76 14.564 0.5 10.163 0.5 5.00001C0.5 4.46201 0.535 3.93101 0.604 3.41101C0.621528 3.29515 0.67919 3.18913 0.766919 3.11145C0.854649 3.03378 0.966873 2.98938 1.084 2.98601C3.67927 2.86326 6.16379 1.89882 8.161 0.23701ZM12.357 6.19101C12.474 6.03002 12.5222 5.82917 12.491 5.63263C12.4599 5.43609 12.352 5.25997 12.191 5.14301C12.03 5.02605 11.8292 4.97783 11.6326 5.00896C11.4361 5.04009 11.26 5.14802 11.143 5.30901L7.66 10.099L5.78 8.21901C5.71078 8.14741 5.628 8.09031 5.53647 8.05105C5.44495 8.01179 5.34653 7.99115 5.24694 7.99033C5.14736 7.98951 5.04861 8.00853 4.95646 8.04629C4.8643 8.08404 4.78059 8.13977 4.7102 8.21022C4.63982 8.28067 4.58417 8.36444 4.5465 8.45663C4.50883 8.54882 4.4899 8.64759 4.49081 8.74717C4.49173 8.84675 4.51246 8.94516 4.55181 9.03664C4.59116 9.12813 4.64834 9.21086 4.72 9.28001L7.22 11.78C7.29663 11.8567 7.38896 11.9158 7.49065 11.9534C7.59233 11.9909 7.70094 12.006 7.80901 11.9975C7.91708 11.9891 8.02203 11.9573 8.11663 11.9044C8.21123 11.8515 8.29324 11.7787 8.357 11.691L12.357 6.19101Z"
      fill="#10B981"
    />
  </svg>
);

export const MembershipIcon: SVGComponent = (props) => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.60268 0.654334C6.98152 -0.218111 8.27179 -0.218112 8.65062 0.654334L10.2027 4.22878L14.2314 4.53815C15.2147 4.61366 15.6134 5.78908 14.8642 6.40379L11.7948 8.92229L12.7326 12.6879C12.9614 13.607 11.9176 14.3335 11.0757 13.841L7.62665 11.823L4.17757 13.841C3.33572 14.3335 2.29187 13.607 2.52076 12.6879L3.45851 8.92229L0.389105 6.40379C-0.360069 5.78908 0.0386445 4.61366 1.02195 4.53815L5.0506 4.22878L6.60268 0.654334ZM7.62665 1.70062L6.25084 4.86912C6.09113 5.23692 5.73003 5.48823 5.31549 5.52006L1.74438 5.79429L4.46519 8.02677C4.78102 8.28591 4.91895 8.69253 4.82246 9.08L3.99121 12.418L7.04858 10.6292C7.40348 10.4216 7.84983 10.4216 8.20473 10.6292L11.2621 12.418L10.4308 9.08C10.3344 8.69253 10.4723 8.28591 10.7881 8.02677L13.5089 5.79429L9.93782 5.52006C9.52328 5.48823 9.16218 5.23692 9.00247 4.86912L7.62665 1.70062Z"
      fill="#585C62"
    />
  </svg>
);

export const InvoiceIcon: SVGComponent = (props) => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.8999 10.0001C2.8999 9.66878 3.16853 9.40015 3.4999 9.40015H8.4999C8.83127 9.40015 9.0999 9.66878 9.0999 10.0001C9.0999 10.3315 8.83127 10.6001 8.4999 10.6001H3.4999C3.16853 10.6001 2.8999 10.3315 2.8999 10.0001Z"
      fill="#585C62"
    />
    <path
      d="M2.8999 12.0001C2.8999 11.6688 3.16853 11.4001 3.4999 11.4001H5.9999C6.33127 11.4001 6.5999 11.6688 6.5999 12.0001C6.5999 12.3315 6.33127 12.6001 5.9999 12.6001H3.4999C3.16853 12.6001 2.8999 12.3315 2.8999 12.0001Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.7499 0.900146C1.00432 0.900146 0.399902 1.50456 0.399902 2.25015V13.7501C0.399902 14.4957 1.00432 15.1001 1.7499 15.1001H10.2499C10.9955 15.1001 11.5999 14.4957 11.5999 13.7501V7.50015C11.5999 3.85507 8.64498 0.900146 4.9999 0.900146H1.7499ZM1.7499 2.10015C1.66706 2.10015 1.5999 2.1673 1.5999 2.25015V13.7501C1.5999 13.833 1.66706 13.9001 1.7499 13.9001H10.2499C10.3327 13.9001 10.3999 13.833 10.3999 13.7501V7.75015C10.3999 6.83888 9.66117 6.10015 8.7499 6.10015H7.7499C7.00432 6.10015 6.3999 5.49573 6.3999 4.75015V3.75015C6.3999 2.83888 5.66117 2.10015 4.7499 2.10015H1.7499ZM7.38061 2.65192C7.52188 2.98991 7.5999 3.36092 7.5999 3.75015V4.75015C7.5999 4.83299 7.66706 4.90015 7.7499 4.90015H8.7499C9.13913 4.90015 9.51014 4.97817 9.84813 5.11944C9.32154 4.0491 8.45095 3.1785 7.38061 2.65192Z"
      fill="#585C62"
    />
  </svg>
);

export const MembershipSolidIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99934 1.75C8.30229 1.75 8.57549 1.93226 8.69183 2.21198L10.1029 5.60466L13.7656 5.8983C14.0676 5.92251 14.3254 6.12601 14.419 6.41413C14.5126 6.70226 14.4237 7.01841 14.1936 7.21549L11.403 9.60592L12.2556 13.1801C12.3259 13.4748 12.212 13.7828 11.9669 13.9609C11.7218 14.1389 11.3936 14.1521 11.1351 13.9942L7.99934 12.0788L4.86357 13.9942C4.60503 14.1521 4.27688 14.1389 4.03179 13.9609C3.7867 13.7828 3.6728 13.4748 3.7431 13.1801L4.59566 9.60592L1.80508 7.21549C1.57501 7.01841 1.48609 6.70226 1.57971 6.41413C1.67333 6.12601 1.93109 5.92251 2.23307 5.8983L5.89575 5.60466L7.30685 2.21198C7.42319 1.93226 7.69639 1.75 7.99934 1.75Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const DollarIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.375 5.5H7.25V7.25H6.375C5.89175 7.25 5.5 6.85825 5.5 6.375C5.5 5.89175 5.89175 5.5 6.375 5.5Z"
      fill="#81888F"
    />
    <path
      d="M8.75 10.5V8.75H9.625C10.1082 8.75 10.5 9.14175 10.5 9.625C10.5 10.1082 10.1082 10.5 9.625 10.5H8.75Z"
      fill="#81888F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.25 3.75C7.25 3.33579 7.58579 3 8 3C8.41421 3 8.75 3.33579 8.75 3.75V4H11.25C11.6642 4 12 4.33579 12 4.75C12 5.16421 11.6642 5.5 11.25 5.5H8.75V7.25H9.625C10.9367 7.25 12 8.31332 12 9.625C12 10.9367 10.9367 12 9.625 12H8.75V12.25C8.75 12.6642 8.41421 13 8 13C7.58579 13 7.25 12.6642 7.25 12.25V12H4.75C4.33579 12 4 11.6642 4 11.25C4 10.8358 4.33579 10.5 4.75 10.5H7.25V8.75H6.375C5.06332 8.75 4 7.68668 4 6.375C4 5.06332 5.06332 4 6.375 4H7.25V3.75Z"
      fill="#81888F"
    />
  </svg>
);

export const PaymentPlanIcon: SVGComponent = (props) => (
  <svg width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50015 1.40002C4.83152 1.40002 5.10015 1.66865 5.10015 2.00002V2.90002H10.9001V2.00002C10.9001 1.66865 11.1688 1.40002 11.5001 1.40002C11.8315 1.40002 12.1001 1.66865 12.1001 2.00002V2.90002H12.5001C13.6599 2.90002 14.6001 3.84023 14.6001 5.00002V12.5C14.6001 13.6598 13.6599 14.6 12.5001 14.6H3.50015C2.34035 14.6 1.40015 13.6598 1.40015 12.5V5.00002C1.40015 3.84023 2.34035 2.90002 3.50015 2.90002H3.90015V2.00002C3.90015 1.66865 4.16878 1.40002 4.50015 1.40002ZM3.50015 4.10002C3.00309 4.10002 2.60015 4.50297 2.60015 5.00002V5.60211C2.87292 5.47253 3.17807 5.40002 3.50015 5.40002H12.5001C12.8222 5.40002 13.1274 5.47253 13.4001 5.60211V5.00002C13.4001 4.50297 12.9972 4.10002 12.5001 4.10002H3.50015ZM13.4001 7.50002C13.4001 7.00297 12.9972 6.60002 12.5001 6.60002H3.50015C3.00309 6.60002 2.60015 7.00297 2.60015 7.50002V12.5C2.60015 12.9971 3.00309 13.4 3.50015 13.4H12.5001C12.9972 13.4 13.4001 12.9971 13.4001 12.5V7.50002Z"
      fill="#585C62"
    />
  </svg>
);

export const StatementIcon: SVGComponent = (props) => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.86667 0.666992C1.24301 0.666992 0.697867 0.979812 0.362883 1.44561C0.133827 1.76411 0 2.15699 0 2.57811V9.42253C0 10.455 0.813093 11.3337 1.86667 11.3337H7.46667C7.83487 11.3337 8.13333 11.0352 8.13333 10.667C8.13333 10.2988 7.83487 10.0003 7.46667 10.0003H1.86667C1.59476 10.0003 1.33333 9.76473 1.33333 9.42253V3.29877L5.18632 7.54006C5.97991 8.41359 7.3534 8.41359 8.147 7.54006L12 3.29877V6.75586C12 7.12406 12.2985 7.42253 12.6667 7.42253C13.0349 7.42253 13.3333 7.12406 13.3333 6.75586V2.57811C13.3333 2.15699 13.1995 1.76411 12.9705 1.44561C12.6355 0.979812 12.0903 0.666992 11.4667 0.666992H1.86667ZM6.17322 6.64346L1.95513 2.00033H11.3782L7.16013 6.64346C6.8956 6.93466 6.43775 6.93466 6.17322 6.64346ZM15.1929 9.07626C15.4189 8.78566 15.3666 8.36679 15.0759 8.14073C14.7853 7.91473 14.3665 7.96706 14.1404 8.25773L11.4845 11.6724L10.4627 10.6871C10.1977 10.4315 9.77567 10.4392 9.52013 10.7043C9.26453 10.9693 9.2722 11.3913 9.53727 11.6469L11.0928 13.1469C11.2289 13.2781 11.4144 13.3455 11.603 13.332C11.7917 13.3185 11.9657 13.2256 12.0818 13.0763L15.1929 9.07626Z"
      fill="#585C62"
    />
  </svg>
);

export const AppointmentIcon: SVGComponent = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.3999 7.4999C6.3999 7.16853 6.66853 6.8999 6.9999 6.8999H7.0049C7.33627 6.8999 7.6049 7.16853 7.6049 7.4999V7.5049C7.6049 7.83627 7.33627 8.1049 7.0049 8.1049H6.9999C6.66853 8.1049 6.3999 7.83627 6.3999 7.5049V7.4999Z"
      fill="#585C62"
    />
    <path
      d="M7.8999 7.4999C7.8999 7.16853 8.16853 6.8999 8.4999 6.8999H8.5049C8.83627 6.8999 9.1049 7.16853 9.1049 7.4999V7.5049C9.1049 7.83627 8.83627 8.1049 8.5049 8.1049H8.4999C8.16853 8.1049 7.8999 7.83627 7.8999 7.5049V7.4999Z"
      fill="#585C62"
    />
    <path
      d="M9.3999 7.4999C9.3999 7.16853 9.66853 6.8999 9.9999 6.8999H10.0049C10.3363 6.8999 10.6049 7.16853 10.6049 7.4999V7.5049C10.6049 7.83627 10.3363 8.1049 10.0049 8.1049H9.9999C9.66853 8.1049 9.3999 7.83627 9.3999 7.5049V7.4999Z"
      fill="#585C62"
    />
    <path
      d="M3.3999 8.9999C3.3999 8.66853 3.66853 8.3999 3.9999 8.3999H4.0049C4.33627 8.3999 4.6049 8.66853 4.6049 8.9999V9.0049C4.6049 9.33627 4.33627 9.6049 4.0049 9.6049H3.9999C3.66853 9.6049 3.3999 9.33627 3.3999 9.0049V8.9999Z"
      fill="#585C62"
    />
    <path
      d="M4.8999 8.9999C4.8999 8.66853 5.16853 8.3999 5.4999 8.3999H5.5049C5.83627 8.3999 6.1049 8.66853 6.1049 8.9999V9.0049C6.1049 9.33627 5.83627 9.6049 5.5049 9.6049H5.4999C5.16853 9.6049 4.8999 9.33627 4.8999 9.0049V8.9999Z"
      fill="#585C62"
    />
    <path
      d="M6.3999 8.9999C6.3999 8.66853 6.66853 8.3999 6.9999 8.3999H7.0049C7.33627 8.3999 7.6049 8.66853 7.6049 8.9999V9.0049C7.6049 9.33627 7.33627 9.6049 7.0049 9.6049H6.9999C6.66853 9.6049 6.3999 9.33627 6.3999 9.0049V8.9999Z"
      fill="#585C62"
    />
    <path
      d="M7.8999 8.9999C7.8999 8.66853 8.16853 8.3999 8.4999 8.3999H8.5049C8.83627 8.3999 9.1049 8.66853 9.1049 8.9999V9.0049C9.1049 9.33627 8.83627 9.6049 8.5049 9.6049H8.4999C8.16853 9.6049 7.8999 9.33627 7.8999 9.0049V8.9999Z"
      fill="#585C62"
    />
    <path
      d="M9.3999 8.9999C9.3999 8.66853 9.66853 8.3999 9.9999 8.3999H10.0049C10.3363 8.3999 10.6049 8.66853 10.6049 8.9999V9.0049C10.6049 9.33627 10.3363 9.6049 10.0049 9.6049H9.9999C9.66853 9.6049 9.3999 9.33627 9.3999 9.0049V8.9999Z"
      fill="#585C62"
    />
    <path
      d="M3.3999 10.4999C3.3999 10.1685 3.66853 9.8999 3.9999 9.8999H4.0049C4.33627 9.8999 4.6049 10.1685 4.6049 10.4999V10.5049C4.6049 10.8363 4.33627 11.1049 4.0049 11.1049H3.9999C3.66853 11.1049 3.3999 10.8363 3.3999 10.5049V10.4999Z"
      fill="#585C62"
    />
    <path
      d="M4.8999 10.4999C4.8999 10.1685 5.16853 9.8999 5.4999 9.8999H5.5049C5.83627 9.8999 6.1049 10.1685 6.1049 10.4999V10.5049C6.1049 10.8363 5.83627 11.1049 5.5049 11.1049H5.4999C5.16853 11.1049 4.8999 10.8363 4.8999 10.5049V10.4999Z"
      fill="#585C62"
    />
    <path
      d="M6.3999 10.4999C6.3999 10.1685 6.66853 9.8999 6.9999 9.8999H7.0049C7.33627 9.8999 7.6049 10.1685 7.6049 10.4999V10.5049C7.6049 10.8363 7.33627 11.1049 7.0049 11.1049H6.9999C6.66853 11.1049 6.3999 10.8363 6.3999 10.5049V10.4999Z"
      fill="#585C62"
    />
    <path
      d="M7.8999 10.4999C7.8999 10.1685 8.16853 9.8999 8.4999 9.8999H8.5049C8.83627 9.8999 9.1049 10.1685 9.1049 10.4999V10.5049C9.1049 10.8363 8.83627 11.1049 8.5049 11.1049H8.4999C8.16853 11.1049 7.8999 10.8363 7.8999 10.5049V10.4999Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.4999 0.399902C3.83127 0.399902 4.0999 0.668531 4.0999 0.999902V1.8999H9.8999V0.999902C9.8999 0.668531 10.1685 0.399902 10.4999 0.399902C10.8313 0.399902 11.0999 0.668531 11.0999 0.999902V1.8999H11.4999C12.6597 1.8999 13.5999 2.8401 13.5999 3.9999V11.4999C13.5999 12.6597 12.6597 13.5999 11.4999 13.5999H2.4999C1.3401 13.5999 0.399902 12.6597 0.399902 11.4999V3.9999C0.399902 2.8401 1.3401 1.8999 2.4999 1.8999H2.8999V0.999902C2.8999 0.668531 3.16853 0.399902 3.4999 0.399902ZM2.4999 3.0999C2.00285 3.0999 1.5999 3.50285 1.5999 3.9999V4.60199C1.87268 4.47241 2.17782 4.3999 2.4999 4.3999H11.4999C11.822 4.3999 12.1271 4.47241 12.3999 4.60199V3.9999C12.3999 3.50285 11.997 3.0999 11.4999 3.0999H2.4999ZM12.3999 6.4999C12.3999 6.00285 11.997 5.5999 11.4999 5.5999H2.4999C2.00285 5.5999 1.5999 6.00285 1.5999 6.4999V11.4999C1.5999 11.997 2.00285 12.3999 2.4999 12.3999H11.4999C11.997 12.3999 12.3999 11.997 12.3999 11.4999V6.4999Z"
      fill="#585C62"
    />
  </svg>
);

export const OutreachIcon: SVGComponent = (props) => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.70844 14.8161L9.08665 14.1771L8.18602 13.644L7.80781 14.283L8.70844 14.8161ZM5.91334 14.1771L6.29156 14.8161L7.19212 14.283L6.81391 13.644L5.91334 14.1771ZM7.80781 14.283C7.67337 14.5102 7.32663 14.5102 7.19212 14.283L6.29156 14.8161C6.83128 15.7279 8.16872 15.7279 8.70844 14.8161L7.80781 14.283ZM6.45349 1.54651H8.54651V0.5H6.45349V1.54651ZM13.9535 6.95349V7.65116H15V6.95349H13.9535ZM1.04651 7.65116V6.95349H1.43759e-07V7.65116H1.04651ZM1.43759e-07 7.65116C1.43759e-07 8.4567 -0.000285926 9.08705 0.0344024 9.59544C0.0694187 10.1086 0.141789 10.5356 0.305365 10.9305L1.27222 10.53C1.17026 10.2839 1.10987 9.98405 1.07849 9.52421C1.0468 9.0597 1.04651 8.471 1.04651 7.65116H1.43759e-07ZM4.57151 12.3546C3.69562 12.3395 3.23667 12.2838 2.87692 12.1348L2.47644 13.1016C3.03805 13.3342 3.67771 13.3858 4.55348 13.4009L4.57151 12.3546ZM0.305365 10.9305C0.712521 11.9135 1.49348 12.6944 2.47644 13.1016L2.87692 12.1348C2.15039 11.8338 1.57316 11.2566 1.27222 10.53L0.305365 10.9305ZM13.9535 7.65116C13.9535 8.471 13.9532 9.0597 13.9215 9.52421C13.8901 9.98405 13.8297 10.2839 13.7278 10.53L14.6946 10.9305C14.8582 10.5356 14.9306 10.1086 14.9656 9.59544C15.0003 9.08705 15 8.4567 15 7.65116H13.9535ZM10.4465 13.4009C11.3223 13.3858 11.962 13.3342 12.5235 13.1016L12.1231 12.1348C11.7633 12.2838 11.3043 12.3395 10.4285 12.3546L10.4465 13.4009ZM13.7278 10.53C13.4268 11.2566 12.8496 11.8338 12.1231 12.1348L12.5235 13.1016C13.5065 12.6944 14.2875 11.9135 14.6946 10.9305L13.7278 10.53ZM8.54651 1.54651C9.69851 1.54651 10.5258 1.54706 11.1711 1.60842C11.8086 1.66903 12.2143 1.78528 12.5376 1.98345L13.0845 1.09115C12.569 0.775282 11.9842 0.634505 11.2702 0.566607C10.5638 0.499449 9.67828 0.5 8.54651 0.5V1.54651ZM15 6.95349C15 5.82173 15.0006 4.93616 14.9334 4.22984C14.8655 3.51574 14.7247 2.93101 14.4089 2.41556L13.5165 2.96236C13.7147 3.28575 13.831 3.6914 13.8916 4.3289C13.9529 4.97419 13.9535 5.80146 13.9535 6.95349H15ZM12.5376 1.98345C12.9366 2.22794 13.2721 2.56339 13.5165 2.96236L14.4089 2.41556C14.0781 1.87577 13.6243 1.42193 13.0845 1.09115L12.5376 1.98345ZM6.45349 0.5C5.32173 0.5 4.43616 0.499449 3.72984 0.566607C3.01574 0.634505 2.43101 0.775282 1.91556 1.09115L2.46236 1.98345C2.78575 1.78528 3.1914 1.66903 3.8289 1.60842C4.47419 1.54706 5.30146 1.54651 6.45349 1.54651V0.5ZM1.04651 6.95349C1.04651 5.80146 1.04706 4.97419 1.10842 4.3289C1.16903 3.6914 1.28528 3.28575 1.48345 2.96236L0.591154 2.41556C0.275282 2.93101 0.134505 3.51574 0.0666071 4.22984C-0.000551048 4.93616 1.43759e-07 5.82173 1.43759e-07 6.95349H1.04651ZM1.91556 1.09115C1.37577 1.42193 0.921935 1.87577 0.591154 2.41556L1.48345 2.96236C1.72794 2.56339 2.06339 2.22794 2.46236 1.98345L1.91556 1.09115ZM6.81391 13.644C6.67228 13.4047 6.54795 13.1936 6.42705 13.0277C6.29965 12.853 6.15363 12.6956 5.95106 12.5778L5.42492 13.4825C5.458 13.5016 5.50306 13.5367 5.58129 13.644C5.66597 13.7603 5.76164 13.9208 5.91334 14.1771L6.81391 13.644ZM4.55348 13.4009C4.85983 13.4062 5.05386 13.4101 5.20178 13.4264C5.33999 13.4418 5.39357 13.4642 5.42492 13.4825L5.95106 12.5778C5.74681 12.459 5.53427 12.4103 5.31696 12.3863C5.10934 12.3633 4.85843 12.3596 4.57151 12.3546L4.55348 13.4009ZM9.08665 14.1771C9.23833 13.9208 9.33398 13.7603 9.41867 13.644C9.49688 13.5367 9.54195 13.5016 9.57502 13.4825L9.04891 12.5778C8.84637 12.6956 8.70028 12.853 8.57295 13.0277C8.45205 13.1936 8.32772 13.4047 8.18602 13.644L9.08665 14.1771ZM10.4285 12.3546C10.1415 12.3596 9.89065 12.3633 9.68302 12.3863C9.4657 12.4103 9.25319 12.459 9.04891 12.5778L9.57502 13.4825C9.60642 13.4642 9.66 13.4418 9.79821 13.4264C9.94612 13.4101 10.1401 13.4062 10.4465 13.4009L10.4285 12.3546Z"
      fill="#585C62"
    />
    <path d="M4.70947 7.30176H4.71575ZM7.49389 7.30176H7.50017ZM10.2846 7.30176H10.2909Z" fill="#585C62" />
    <path
      d="M4.70947 7.30176H4.71575M7.49389 7.30176H7.50017M10.2846 7.30176H10.2909"
      stroke="#585C62"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon: SVGComponent = (props) => (
  <svg
    width="632"
    height="627"
    viewBox="0 0 632 627"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M544.817 219.583L411.483 86.25M544.817 219.583L378.2 386.197C356.243 408.153 329.593 425.487 298.997 430.763C268.103 436.093 229.765 437.867 211.481 419.583C193.198 401.3 194.972 362.96 200.3 332.067C205.577 301.47 222.912 274.82 244.867 252.863L411.483 86.25M544.817 219.583C544.817 219.583 644.813 119.583 578.147 52.9167C511.48 -13.75 411.483 86.25 411.483 86.25M596.667 313.333C596.667 530 530 596.667 313.333 596.667C96.6667 596.667 30 530 30 313.333C30 96.6667 96.6667 30 313.333 30"
      stroke="white"
      strokeWidth="60"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlertIcon: SVGComponent = (props) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-3 w-3"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

export const NoteIcon: SVGComponent = (props) => (
  <svg width="16" height="18" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.94887 20.3948H13.0511C15.0202 20.3948 16 19.396 16 17.4174V8.78004C16 7.55294 15.8668 7.0202 15.1058 6.2402L9.85493 0.903663C9.132 0.161697 8.5422 0 7.4673 0H2.94887C0.9893 0 0 1.00834 0 2.98694V17.4174C0 19.4055 0.9893 20.3948 2.94887 20.3948ZM3.02497 18.8633C2.04516 18.8633 1.5315 18.3401 1.5315 17.3888V3.01547C1.5315 2.07374 2.04516 1.5315 3.03446 1.5315H7.258V7.05827C7.258 8.25683 7.8668 8.8466 9.04637 8.8466H14.4685V17.3888C14.4685 18.3401 13.9643 18.8633 12.975 18.8633H3.02497ZM9.2176 7.41023C8.8466 7.41023 8.6944 7.25804 8.6944 6.87753V1.8264L14.1736 7.41023H9.2176ZM11.5006 11.4626H4.2806C3.93817 11.4626 3.69083 11.7194 3.69083 12.0428C3.69083 12.3758 3.93817 12.6326 4.2806 12.6326H11.5006C11.8335 12.6326 12.0904 12.3758 12.0904 12.0428C12.0904 11.7194 11.8335 11.4626 11.5006 11.4626ZM11.5006 14.7824H4.2806C3.93817 14.7824 3.69083 15.0488 3.69083 15.3817C3.69083 15.7051 3.93817 15.9525 4.2806 15.9525H11.5006C11.8335 15.9525 12.0904 15.7051 12.0904 15.3817C12.0904 15.0488 11.8335 14.7824 11.5006 14.7824Z"
      fill="#6C727F"
    />
  </svg>
);

export const HelpIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 9.5C18 14.1945 14.1945 18 9.5 18C4.80558 18 1 14.1945 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1945 1 18 4.80558 18 9.5Z"
      stroke="#6C727F"
      strokeWidth="1.5"
    />
    <path
      d="M8.08398 6.36164C8.43012 5.9695 8.93653 5.72217 9.50065 5.72217C10.5439 5.72217 11.3895 6.56785 11.3895 7.61106C11.3895 8.49288 10.7852 9.23361 9.96806 9.44167C9.71532 9.50599 9.50065 9.71141 9.50065 9.97217V10.4444"
      stroke="#6C727F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 13.2778H9.50944"
      stroke="#6C727F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellIcon: SVGComponent = (props) => (
  <svg width="14" height="16" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.3743 6.56802V6.05914C12.3743 3.26505 10.192 1 7.5 1C4.80796 1 2.62563 3.26505 2.62563 6.05914V6.56802C2.62563 7.17875 2.45146 7.77574 2.12508 8.2839L1.32526 9.52908C0.594704 10.6664 1.15243 12.2124 2.42304 12.5721C5.74698 13.513 9.25305 13.513 12.5769 12.5721C13.8476 12.2124 14.4053 10.6664 13.6747 9.52908L12.8749 8.2839C12.5485 7.77574 12.3743 7.17875 12.3743 6.56802Z"
      stroke="#6C727F"
      strokeWidth="1.5"
    />
    <path
      d="M4.25 13.2777C4.72308 14.54 5.99955 15.4444 7.5 15.4444C9.00042 15.4444 10.2769 14.54 10.75 13.2777"
      stroke="#6C727F"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const UserIcon: SVGComponent = (props) => (
  <svg width="14" height="16" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.5 8.5C10.5711 8.5 12.25 6.82107 12.25 4.75C12.25 2.67893 10.5711 1 8.5 1C6.42893 1 4.75 2.67893 4.75 4.75C4.75 6.82107 6.42893 8.5 8.5 8.5Z"
      stroke="#6C727F"
      strokeWidth="2"
    />
    <path
      d="M16 15.5312C16 17.8612 16 19.75 8.5 19.75C1 19.75 1 17.8612 1 15.5312C1 13.2013 4.35786 11.3125 8.5 11.3125C12.6422 11.3125 16 13.2013 16 15.5312Z"
      stroke="#6C727F"
      strokeWidth="2"
    />
  </svg>
);

export const PayoutIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00015 3.40002C8.33152 3.40002 8.60015 3.66865 8.60015 4.00002V4.46123C9.00381 4.54488 9.38714 4.71434 9.70844 4.96958L9.98504 5.18931C10.2445 5.39542 10.2877 5.77285 10.0816 6.03232C9.87551 6.29178 9.49808 6.33503 9.23862 6.12891L8.96202 5.90919C8.8549 5.82409 8.73212 5.75656 8.60015 5.7066V7.45571C9.01963 7.53468 9.42752 7.6992 9.77439 7.95937C10.2923 8.34785 10.6001 8.89958 10.6001 9.50002C10.6001 10.1005 10.2923 10.6522 9.77439 11.0407C9.42752 11.3008 9.01963 11.4654 8.60015 11.5443V12C8.60015 12.3314 8.33152 12.6 8.00015 12.6C7.66878 12.6 7.40015 12.3314 7.40015 12V11.5443C6.98072 11.4653 6.57289 11.3008 6.22605 11.0407L5.64014 10.6012C5.37504 10.4024 5.32133 10.0263 5.52015 9.76122C5.71898 9.49613 6.09506 9.44241 6.36016 9.64124L6.94607 10.0807C7.07525 10.1776 7.2297 10.255 7.40015 10.3093V8.53887C7.00298 8.45665 6.61842 8.29007 6.29167 8.0305C5.79552 7.63636 5.51183 7.08622 5.51183 6.50004C5.51183 5.91386 5.79552 5.36372 6.29167 4.96958C6.61302 4.7143 6.99642 4.54483 7.40015 4.46119V4.00002C7.40015 3.66865 7.66878 3.40002 8.00015 3.40002ZM7.40015 5.70653C7.2681 5.75649 7.14526 5.82405 7.03809 5.90919C6.79684 6.10083 6.71183 6.31846 6.71183 6.50004C6.71183 6.68163 6.79684 6.89925 7.03809 7.0909C7.14294 7.1742 7.26556 7.24245 7.40015 7.29343V5.70653ZM8.60015 8.69073V10.3093C8.77065 10.255 8.92515 10.1776 9.05437 10.0807C9.31744 9.88338 9.40015 9.66735 9.40015 9.50002C9.40015 9.3327 9.31744 9.11666 9.05437 8.91936C8.92515 8.82244 8.77065 8.74504 8.60015 8.69073Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.40015 8.00002C1.40015 4.35495 4.35507 1.40002 8.00015 1.40002C11.6452 1.40002 14.6001 4.35495 14.6001 8.00002C14.6001 11.6451 11.6452 14.6 8.00015 14.6C4.35507 14.6 1.40015 11.6451 1.40015 8.00002ZM8.00015 2.60002C5.01781 2.60002 2.60015 5.01769 2.60015 8.00002C2.60015 10.9824 5.01781 13.4 8.00015 13.4C10.9825 13.4 13.4001 10.9824 13.4001 8.00002C13.4001 5.01769 10.9825 2.60002 8.00015 2.60002Z"
      fill="#585C62"
    />
  </svg>
);

export const CatalogIcon: SVGComponent = (props) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 0C6.13437 0 5.79764 0.090873 5.42904 0.243324C5.07307 0.390532 4.65964 0.607499 4.14482 0.877669L2.8947 1.5337C2.26286 1.86527 1.75721 2.13062 1.3668 2.39134C0.962327 2.66146 0.650798 2.94587 0.423933 3.33113C0.19783 3.7151 0.0961155 4.13088 0.0473383 4.62602C-5.91957e-06 5.10663 -5.91213e-06 5.69769 1.34385e-07 6.44111V6.55889C-5.91213e-06 7.30225 -5.91957e-06 7.89336 0.0473383 8.374C0.0961155 8.86914 0.19783 9.2849 0.423933 9.66886C0.650798 10.0541 0.962327 10.3386 1.3668 10.6087C1.75719 10.8694 2.2628 11.1347 2.8946 11.4662L4.1448 12.1223C4.65961 12.3925 5.07307 12.6095 5.42904 12.7567C5.79764 12.9091 6.13437 13 6.5 13C6.86563 13 7.20236 12.9091 7.57096 12.7567C7.92692 12.6095 8.34038 12.3925 8.85518 12.1223L10.1053 11.4663C10.7372 11.1347 11.2428 10.8694 11.6332 10.6087C12.0377 10.3386 12.3492 10.0541 12.5761 9.66886C12.8022 9.2849 12.9039 8.86914 12.9527 8.374C13 7.89336 13 7.30231 13 6.55895V6.44105C13 5.69769 13 5.10662 12.9527 4.62602C12.9039 4.13088 12.8022 3.7151 12.5761 3.33113C12.3492 2.94587 12.0377 2.66146 11.6332 2.39134C11.2428 2.13062 10.7372 1.86527 10.1053 1.5337L8.85518 0.877675C8.34038 0.607505 7.92692 0.390538 7.57096 0.243324C7.20236 0.090873 6.86563 0 6.5 0ZM4.54746 1.69065C5.08543 1.40834 5.46242 1.211 5.77563 1.08145C6.08049 0.955373 6.29472 0.906977 6.5 0.906977C6.70528 0.906977 6.91951 0.955373 7.22437 1.08145C7.53758 1.211 7.91458 1.40834 8.45254 1.69065L9.66184 2.32526C10.3207 2.67103 10.7837 2.91461 11.1295 3.14559C11.3001 3.25954 11.4342 3.36536 11.5425 3.47175L6.5 5.993L1.45754 3.47175C1.56578 3.36536 1.69987 3.25954 1.8705 3.14559C2.21637 2.91461 2.67928 2.67103 3.33816 2.32526L4.54746 1.69065ZM1.02046 4.26724C0.989923 4.39657 0.966843 4.54342 0.949943 4.71494C0.907485 5.14594 0.906977 5.69243 0.906977 6.46463V6.53537C0.906977 7.30757 0.907485 7.85406 0.949943 8.28505C0.991471 8.70661 1.07037 8.97919 1.20548 9.20866C1.33983 9.43679 1.53416 9.6298 1.8705 9.85442C2.21637 10.0854 2.67928 10.329 3.33816 10.6748L4.54746 11.3093C5.08543 11.5916 5.46242 11.789 5.77563 11.9185C5.87455 11.9595 5.96392 11.9922 6.04651 12.0177V6.78026L1.02046 4.26724ZM6.95349 12.0177C7.03608 11.9922 7.12545 11.9595 7.22437 11.9185C7.53758 11.789 7.91458 11.5916 8.45254 11.3093L9.66184 10.6748C10.3207 10.329 10.7837 10.0854 11.1295 9.85442C11.4658 9.6298 11.6602 9.43679 11.7945 9.20866C11.9296 8.97919 12.0086 8.70661 12.05 8.28505C12.0925 7.85406 12.093 7.30757 12.093 6.53537V6.46463C12.093 5.69243 12.0925 5.14594 12.05 4.71494C12.0332 4.54342 12.0101 4.39657 11.9795 4.26724L6.95349 6.78026V12.0177Z"
      fill="#585C62"
    />
  </svg>
);

export const SettingIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40016 7.99997C5.40016 6.56403 6.56422 5.39997 8.00016 5.39997C9.4361 5.39997 10.6002 6.56403 10.6002 7.99997C10.6002 9.43591 9.4361 10.6 8.00016 10.6C6.56422 10.6 5.40016 9.43591 5.40016 7.99997ZM8.00016 6.59997C7.22696 6.59997 6.60016 7.22677 6.60016 7.99997C6.60016 8.77317 7.22696 9.39997 8.00016 9.39997C8.77336 9.39997 9.40016 8.77317 9.40016 7.99997C9.40016 7.22677 8.77336 6.59997 8.00016 6.59997Z"
      fill="#585C62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.80403 2.52809C5.91252 1.87713 6.47573 1.40002 7.13566 1.40002H8.86497C9.5249 1.40002 10.0881 1.87713 10.1966 2.52809L10.3389 3.38212C10.3458 3.42304 10.3797 3.48696 10.4671 3.53532C10.5231 3.56635 10.5785 3.5984 10.6333 3.63145C10.7187 3.68302 10.791 3.68051 10.8299 3.66593L11.6411 3.36201C12.2591 3.13049 12.9539 3.37969 13.2839 3.95121L14.1485 5.44883C14.4785 6.02035 14.3469 6.74666 13.8374 7.16609L13.1679 7.7173C13.1357 7.74374 13.0976 7.80491 13.0994 7.90393C13.1 7.93589 13.1003 7.96793 13.1003 8.00002C13.1003 8.03211 13.1 8.06414 13.0994 8.0961C13.0976 8.19513 13.1357 8.2563 13.1679 8.28274L13.8374 8.83395C14.3469 9.25338 14.4785 9.97969 14.1485 10.5512L13.2839 12.0488C12.9539 12.6204 12.2591 12.8695 11.6411 12.638L10.8299 12.3341C10.791 12.3195 10.7187 12.317 10.6333 12.3686C10.5785 12.4016 10.5231 12.4337 10.4671 12.4647C10.3797 12.5131 10.3458 12.577 10.3389 12.6179L10.1966 13.472C10.0881 14.1229 9.5249 14.6 8.86497 14.6H7.13566C6.47573 14.6 5.91252 14.1229 5.80403 13.472L5.66169 12.6179C5.65487 12.577 5.62094 12.5131 5.53356 12.4647C5.47751 12.4337 5.4221 12.4016 5.36737 12.3686C5.28196 12.317 5.20963 12.3195 5.17073 12.3341L4.35948 12.638C3.74149 12.8696 3.0467 12.6204 2.71674 12.0488L1.85208 10.5512C1.52212 9.9797 1.6537 9.25339 2.1632 8.83396L2.83276 8.28275C2.86488 8.25631 2.90304 8.19514 2.9012 8.09612C2.90061 8.06415 2.90031 8.03212 2.90031 8.00002C2.90031 7.96793 2.90061 7.93591 2.9012 7.90394C2.90304 7.80492 2.86488 7.74375 2.83276 7.71731L2.1632 7.1661C1.6537 6.74667 1.52212 6.02036 1.85208 5.44884L2.71674 3.95122C3.0467 3.3797 3.74149 3.1305 4.35948 3.36202L5.17072 3.66594C5.20962 3.68051 5.28195 3.68303 5.36736 3.63145C5.42209 3.59841 5.4775 3.56635 5.53356 3.53532C5.62094 3.48696 5.65487 3.42304 5.66169 3.38212L5.80403 2.52809ZM7.13566 2.60002C7.06233 2.60002 6.99976 2.65304 6.9877 2.72536L6.84536 3.5794C6.76906 4.0372 6.4697 4.38871 6.11472 4.58521C6.07187 4.60892 6.02951 4.63343 5.98766 4.6587C5.63969 4.86882 5.18491 4.9527 4.74973 4.78967L3.9385 4.48575C3.86983 4.46003 3.79263 4.48771 3.75597 4.55122L2.89131 6.04884C2.85465 6.11234 2.86927 6.19305 2.92588 6.23965L3.59545 6.79086C3.95334 7.08549 4.10852 7.52011 4.101 7.92616C4.10054 7.95072 4.10031 7.97534 4.10031 8.00002C4.10031 8.02471 4.10054 8.04933 4.101 8.07389C4.10852 8.47995 3.95334 8.91457 3.59545 9.2092L2.92588 9.76041C2.86927 9.80701 2.85465 9.88771 2.89131 9.95122L3.75597 11.4488C3.79263 11.5123 3.86983 11.54 3.9385 11.5143L4.74974 11.2104C5.18492 11.0474 5.6397 11.1312 5.98767 11.3414C6.02952 11.3666 6.07187 11.3911 6.11472 11.4148C6.4697 11.6113 6.76906 11.9628 6.84536 12.4207L6.9877 13.2747C6.99976 13.347 7.06233 13.4 7.13566 13.4H8.86497C8.9383 13.4 9.00087 13.347 9.01293 13.2747L9.15527 12.4207C9.23157 11.9628 9.53093 11.6113 9.88591 11.4148C9.92876 11.3911 9.97112 11.3666 10.013 11.3413C10.3609 11.1312 10.8157 11.0473 11.2509 11.2104L12.0621 11.5143C12.1308 11.54 12.208 11.5123 12.2447 11.4488L13.1093 9.95121C13.146 9.8877 13.1314 9.807 13.0747 9.7604L12.4052 9.20919C12.0473 8.91456 11.8921 8.47994 11.8996 8.07389C11.9001 8.04933 11.9003 8.02471 11.9003 8.00002C11.9003 7.97535 11.9001 7.95072 11.8996 7.92615C11.8921 7.5201 12.0473 7.08548 12.4052 6.79085L13.0747 6.23964C13.1314 6.19304 13.146 6.11233 13.1093 6.04883L12.2447 4.55121C12.208 4.4877 12.1308 4.46002 12.0621 4.48574L11.2509 4.78966C10.8157 4.95269 10.3609 4.86881 10.013 4.6587C9.97111 4.63343 9.92876 4.60892 9.88591 4.58521C9.53093 4.38871 9.23157 4.0372 9.15527 3.5794L9.01293 2.72536C9.00087 2.65304 8.9383 2.60002 8.86497 2.60002H7.13566Z"
      fill="#585C62"
    />
  </svg>
);

export const SupportIcon: SVGComponent = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#585C62"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoneIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 667 667" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M68.7297 300H597.937C581.533 168.456 469.32 66.6667 333.333 66.6667C197.346 66.6667 85.133 168.456 68.7297 300ZM597.937 366.667H68.7297C85.133 498.21 197.346 600 333.333 600C469.32 600 581.533 498.21 597.937 366.667ZM0 333.333C0 149.238 149.238 0 333.333 0C517.427 0 666.667 149.238 666.667 333.333C666.667 517.427 517.427 666.667 333.333 666.667C149.238 666.667 0 517.427 0 333.333Z"
      fill="#9DA3AE"
    />
  </svg>
);

export const MessageIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1 8.84861C1 9.84878 1.73847 10.7002 2.73405 10.7959C2.82262 10.8045 2.91127 10.8127 3 10.8207V13.25C3 13.5533 3.18273 13.8268 3.46299 13.9429C3.74324 14.059 4.06583 13.9948 4.28033 13.7803L6.10018 11.9605C5.72131 11.4012 5.5 10.7264 5.5 10V9C5.5 7.067 7.067 5.5 9 5.5H13V4.15148C13 3.15133 12.2615 2.29993 11.266 2.20415C9.86223 2.0691 8.43918 2 7 2C5.56082 2 4.13777 2.0691 2.734 2.20415C1.73845 2.29993 1 3.15133 1 4.15148V8.84861Z"
      fill="#ABB0B5"
    />
    <path
      d="M7 9C7 7.89543 7.89543 7 9 7H13C14.1046 7 15 7.89543 15 9V10C15 11.1046 14.1046 12 13 12H12.75V13.25C12.75 13.5533 12.5673 13.8268 12.287 13.9429C12.0068 14.059 11.6842 13.9948 11.4697 13.7803L9.68934 12H9C7.89543 12 7 11.1046 7 10V9Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const TickIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.416 3.37604C12.7607 3.60581 12.8538 4.07146 12.624 4.4161L7.62404 11.9161C7.4994 12.1031 7.2975 12.2243 7.0739 12.2464C6.8503 12.2686 6.62855 12.1893 6.46967 12.0304L3.46967 9.03041C3.17678 8.73752 3.17678 8.26264 3.46967 7.96975C3.76256 7.67686 4.23744 7.67686 4.53033 7.96975L6.88343 10.3229L11.376 3.58405C11.6057 3.23941 12.0714 3.14628 12.416 3.37604Z"
      fill="white"
    />
  </svg>
);

export const DetailIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3.75C2 3.33579 2.33579 3 2.75 3H13.25C13.6642 3 14 3.33579 14 3.75C14 4.16421 13.6642 4.5 13.25 4.5H2.75C2.33579 4.5 2 4.16421 2 3.75ZM2 8C2 7.58579 2.33579 7.25 2.75 7.25H13.25C13.6642 7.25 14 7.58579 14 8C14 8.41421 13.6642 8.75 13.25 8.75H2.75C2.33579 8.75 2 8.41421 2 8ZM2 12.25C2 11.8358 2.33579 11.5 2.75 11.5H7.25C7.66421 11.5 8 11.8358 8 12.25C8 12.6642 7.66421 13 7.25 13H2.75C2.33579 13 2 12.6642 2 12.25Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const LoadingIcon: SVGComponent = () => (
  <svg
    className="h-5 w-5 animate-spin text-gray-600"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export const BillingLogoIcon: SVGComponent = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 10C0 6.26154 0 4.3923 0.803847 3C1.33046 2.08788 2.08788 1.33046 3 0.803847C4.3923 0 6.26154 0 10 0C13.7385 0 15.6077 0 17 0.803847C17.9121 1.33046 18.6695 2.08788 19.1962 3C20 4.3923 20 6.26154 20 10C20 13.7385 20 15.6077 19.1962 17C18.6695 17.9121 17.9121 18.6695 17 19.1962C15.6077 20 13.7385 20 10 20C6.26154 20 4.3923 20 3 19.1962C2.08788 18.6695 1.33046 17.9121 0.803847 17C0 15.6077 0 13.7385 0 10Z"
      fill="#E5E7E8"
    />
    <g clipPath="url(#clip0_189_1022)">
      <path
        d="M7.48586 7.73745L12.4346 4.8803L9.46533 3.16602L4.51671 6.02312L4.5166 11.7373L7.48583 13.4516L7.48586 7.73745Z"
        fill="#1C1D1F"
      />
      <path
        d="M15.4824 7.92813V13.6424L10.5337 16.4995L7.56445 14.7852L12.5132 11.928V6.21387L15.4824 7.92813Z"
        fill="#1C1D1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_189_1022">
        <rect width="11.3333" height="16" fill="white" transform="translate(4.33301 2)" />
      </clipPath>
    </defs>
  </svg>
);

export const BuildingIcon: SVGComponent = (props) => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 0C0.335786 0 0 0.335786 0 0.75C0 1.16421 0.335786 1.5 0.75 1.5H1V10.5H0.75C0.335786 10.5 0 10.8358 0 11.25C0 11.6642 0.335786 12 0.75 12H2.25C2.66421 12 3 11.6642 3 11.25V9.75C3 9.33579 3.33579 9 3.75 9H5.25C5.66421 9 6 9.33579 6 9.75V11.25C6 11.6642 6.33579 12 6.75 12H7.25C7.66421 12 8 11.6642 8 11.25V1.5H8.25C8.66421 1.5 9 1.16421 9 0.75C9 0.335786 8.66421 0 8.25 0H0.75ZM2.5 3.5C2.5 3.22386 2.72386 3 3 3H3.5C3.77614 3 4 3.22386 4 3.5V4C4 4.27614 3.77614 4.5 3.5 4.5H3C2.72386 4.5 2.5 4.27614 2.5 4V3.5ZM3 5.5C2.72386 5.5 2.5 5.72386 2.5 6V6.5C2.5 6.77614 2.72386 7 3 7H3.5C3.77614 7 4 6.77614 4 6.5V6C4 5.72386 3.77614 5.5 3.5 5.5H3ZM5 3.5C5 3.22386 5.22386 3 5.5 3H6C6.27614 3 6.5 3.22386 6.5 3.5V4C6.5 4.27614 6.27614 4.5 6 4.5H5.5C5.22386 4.5 5 4.27614 5 4V3.5ZM5.5 5.5C5.22386 5.5 5 5.72386 5 6V6.5C5 6.77614 5.22386 7 5.5 7H6C6.27614 7 6.5 6.77614 6.5 6.5V6C6.5 5.72386 6.27614 5.5 6 5.5H5.5Z"
      fill="#81888F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 4C9.94772 4 9.5 4.44772 9.5 5V11C9.5 11.5523 9.94771 12 10.5 12H13.25C13.6642 12 14 11.6642 14 11.25C14 10.8358 13.6642 10.5 13.25 10.5H13V5.5H13.25C13.6642 5.5 14 5.16421 14 4.75C14 4.33579 13.6642 4 13.25 4H10.5ZM11 5.5H11.5C11.7761 5.5 12 5.72386 12 6V6.5C12 6.77614 11.7761 7 11.5 7H11C10.7239 7 10.5 6.77614 10.5 6.5V6C10.5 5.72386 10.7239 5.5 11 5.5ZM11 8C10.7239 8 10.5 8.22386 10.5 8.5V9C10.5 9.27614 10.7239 9.5 11 9.5H11.5C11.7761 9.5 12 9.27614 12 9V8.5C12 8.22386 11.7761 8 11.5 8H11Z"
      fill="#81888F"
    />
  </svg>
);

export const InformationIcon: SVGComponent = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.4751 4.8126C6.4751 4.52265 6.71015 4.2876 7.0001 4.2876H7.00447C7.29442 4.2876 7.52947 4.52265 7.52947 4.8126V4.81697C7.52947 5.10692 7.29442 5.34197 7.00447 5.34197H7.0001C6.71015 5.34197 6.4751 5.10692 6.4751 4.81697V4.8126Z"
      fill="#666D74"
    />
    <path
      d="M6.65796 7.079C6.43376 7.12052 6.20009 7.01152 6.09302 6.79738C5.96335 6.53805 6.06847 6.22269 6.32781 6.09302L6.35201 6.08092C7.08751 5.71317 7.91566 6.37749 7.71622 7.17525L7.34223 8.67119C7.56643 8.62968 7.8001 8.73867 7.90717 8.9528C8.03684 9.21214 7.93173 9.5275 7.67239 9.65717L7.64819 9.66927C6.91269 10.037 6.08454 9.37271 6.28398 8.57495L6.65796 7.079Z"
      fill="#666D74"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.2251 7.0001C1.2251 3.81065 3.81065 1.2251 7.0001 1.2251C10.1895 1.2251 12.7751 3.81065 12.7751 7.0001C12.7751 10.1895 10.1895 12.7751 7.0001 12.7751C3.81065 12.7751 1.2251 10.1895 1.2251 7.0001ZM7.0001 2.2751C4.39055 2.2751 2.2751 4.39055 2.2751 7.0001C2.2751 9.60964 4.39055 11.7251 7.0001 11.7251C9.60964 11.7251 11.7251 9.60964 11.7251 7.0001C11.7251 4.39055 9.60964 2.2751 7.0001 2.2751Z"
      fill="#666D74"
    />
  </svg>
);

export const DollarCircleIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 3.39999C8.3314 3.39999 8.60002 3.66862 8.60002 3.99999V4.4612C9.00368 4.54485 9.38701 4.71431 9.70832 4.96955L9.98492 5.18928C10.2444 5.39539 10.2876 5.77282 10.0815 6.03229C9.87539 6.29175 9.49796 6.335 9.2385 6.12888L8.9619 5.90915C8.85478 5.82406 8.732 5.75653 8.60002 5.70657V7.45568C9.01951 7.53464 9.42739 7.69917 9.77427 7.95934C10.2922 8.34782 10.6 8.89955 10.6 9.49999C10.6 10.1004 10.2922 10.6522 9.77427 11.0406C9.42739 11.3008 9.01951 11.4653 8.60002 11.5443V12C8.60002 12.3314 8.3314 12.6 8.00002 12.6C7.66865 12.6 7.40002 12.3314 7.40002 12V11.5443C6.9806 11.4653 6.57277 11.3008 6.22593 11.0406L5.64002 10.6012C5.37492 10.4024 5.3212 10.0263 5.52003 9.76119C5.71886 9.4961 6.09494 9.44238 6.36003 9.64121L6.94595 10.0807C7.07513 10.1776 7.22958 10.2549 7.40002 10.3092V8.53884C7.00286 8.45662 6.61829 8.29004 6.29154 8.03047C5.79539 7.63633 5.51171 7.08619 5.51171 6.50001C5.51171 5.91383 5.79539 5.36369 6.29155 4.96955C6.6129 4.71427 6.9963 4.5448 7.40002 4.46116V3.99999C7.40002 3.66862 7.66865 3.39999 8.00002 3.39999ZM7.40002 5.7065C7.26798 5.75646 7.14514 5.82402 7.03796 5.90915C6.79672 6.1008 6.71171 6.31843 6.71171 6.50001C6.71171 6.6816 6.79672 6.89922 7.03796 7.09087C7.14282 7.17417 7.26544 7.24242 7.40002 7.2934V5.7065ZM8.60002 8.6907V10.3093C8.77053 10.255 8.92503 10.1776 9.05425 10.0807C9.31732 9.88335 9.40002 9.66732 9.40002 9.49999C9.40002 9.33267 9.31732 9.11663 9.05425 8.91933C8.92503 8.82241 8.77053 8.74501 8.60002 8.6907Z"
      fill="#666D74"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.40002 7.99999C1.40002 4.35491 4.35495 1.39999 8.00002 1.39999C11.6451 1.39999 14.6 4.35491 14.6 7.99999C14.6 11.6451 11.6451 14.6 8.00002 14.6C4.35495 14.6 1.40002 11.6451 1.40002 7.99999ZM8.00002 2.59999C5.01769 2.59999 2.60002 5.01766 2.60002 7.99999C2.60002 10.9823 5.01769 13.4 8.00002 13.4C10.9824 13.4 13.4 10.9823 13.4 7.99999C13.4 5.01766 10.9824 2.59999 8.00002 2.59999Z"
      fill="#666D74"
    />
  </svg>
);

export const DollarCircleWhiteIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 3.39999C8.3314 3.39999 8.60002 3.66862 8.60002 3.99999V4.4612C9.00368 4.54485 9.38701 4.71431 9.70832 4.96955L9.98492 5.18928C10.2444 5.39539 10.2876 5.77282 10.0815 6.03229C9.87539 6.29175 9.49796 6.335 9.2385 6.12888L8.9619 5.90915C8.85478 5.82406 8.732 5.75653 8.60002 5.70657V7.45568C9.01951 7.53464 9.42739 7.69917 9.77427 7.95934C10.2922 8.34782 10.6 8.89955 10.6 9.49999C10.6 10.1004 10.2922 10.6522 9.77427 11.0406C9.42739 11.3008 9.01951 11.4653 8.60002 11.5443V12C8.60002 12.3314 8.3314 12.6 8.00002 12.6C7.66865 12.6 7.40002 12.3314 7.40002 12V11.5443C6.9806 11.4653 6.57277 11.3008 6.22593 11.0406L5.64002 10.6012C5.37492 10.4024 5.3212 10.0263 5.52003 9.76119C5.71886 9.4961 6.09494 9.44238 6.36003 9.64121L6.94595 10.0807C7.07513 10.1776 7.22958 10.2549 7.40002 10.3092V8.53884C7.00286 8.45662 6.61829 8.29004 6.29154 8.03047C5.79539 7.63633 5.51171 7.08619 5.51171 6.50001C5.51171 5.91383 5.79539 5.36369 6.29155 4.96955C6.6129 4.71427 6.9963 4.5448 7.40002 4.46116V3.99999C7.40002 3.66862 7.66865 3.39999 8.00002 3.39999ZM7.40002 5.7065C7.26798 5.75646 7.14514 5.82402 7.03796 5.90915C6.79672 6.1008 6.71171 6.31843 6.71171 6.50001C6.71171 6.6816 6.79672 6.89922 7.03796 7.09087C7.14282 7.17417 7.26544 7.24242 7.40002 7.2934V5.7065ZM8.60002 8.6907V10.3093C8.77053 10.255 8.92503 10.1776 9.05425 10.0807C9.31732 9.88335 9.40002 9.66732 9.40002 9.49999C9.40002 9.33267 9.31732 9.11663 9.05425 8.91933C8.92503 8.82241 8.77053 8.74501 8.60002 8.6907Z"
      fill="#ffffff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.40002 7.99999C1.40002 4.35491 4.35495 1.39999 8.00002 1.39999C11.6451 1.39999 14.6 4.35491 14.6 7.99999C14.6 11.6451 11.6451 14.6 8.00002 14.6C4.35495 14.6 1.40002 11.6451 1.40002 7.99999ZM8.00002 2.59999C5.01769 2.59999 2.60002 5.01766 2.60002 7.99999C2.60002 10.9823 5.01769 13.4 8.00002 13.4C10.9824 13.4 13.4 10.9823 13.4 7.99999C13.4 5.01766 10.9824 2.59999 8.00002 2.59999Z"
      fill="#ffffff"
    />
  </svg>
);

export const ShapeIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.6977 0.981757C7.88452 0.87278 8.11553 0.87278 8.30235 0.981757L9.80235 1.85676C10.0886 2.02373 10.1853 2.39112 10.0183 2.67735C9.85132 2.96358 9.48393 3.06026 9.1977 2.89329L8.00002 2.19465L6.80235 2.89329C6.51612 3.06026 6.14873 2.96358 5.98176 2.67735C5.81479 2.39112 5.91147 2.02373 6.1977 1.85676L7.6977 0.981757Z"
      fill="#666D74"
    />
    <path
      d="M4.01829 3.8227C4.18526 4.10893 4.08858 4.47632 3.80235 4.64329L3.19081 5.00002L3.80235 5.35676C4.08858 5.52373 4.18526 5.89112 4.01829 6.17735C3.85132 6.46358 3.48393 6.56026 3.1977 6.39329L2.60002 6.04465V6.50002C2.60002 6.8314 2.3314 7.10002 2.00002 7.10002C1.66865 7.10002 1.40002 6.8314 1.40002 6.50002V5.00002C1.40002 4.78662 1.51337 4.58928 1.6977 4.48176L3.1977 3.60676C3.48393 3.43979 3.85132 3.53647 4.01829 3.8227Z"
      fill="#666D74"
    />
    <path
      d="M11.9818 3.8227C12.1487 3.53647 12.5161 3.43979 12.8023 3.60676L14.3023 4.48176C14.4867 4.58928 14.6 4.78662 14.6 5.00002V6.50002C14.6 6.8314 14.3314 7.10002 14 7.10002C13.6687 7.10002 13.4 6.8314 13.4 6.50002V6.04465L12.8023 6.39329C12.5161 6.56026 12.1487 6.46358 11.9818 6.17735C11.8148 5.89112 11.9115 5.52373 12.1977 5.35676L12.8092 5.00002L12.1977 4.64329C11.9115 4.47632 11.8148 4.10893 11.9818 3.8227Z"
      fill="#666D74"
    />
    <path
      d="M5.98176 7.3227C6.14873 7.03647 6.51612 6.93979 6.80235 7.10676L8.00002 7.8054L9.1977 7.10676C9.48393 6.93979 9.85132 7.03647 10.0183 7.3227C10.1853 7.60893 10.0886 7.97632 9.80235 8.14329L8.60002 8.84465V10C8.60002 10.3314 8.3314 10.6 8.00002 10.6C7.66865 10.6 7.40002 10.3314 7.40002 10V8.84465L6.1977 8.14329C5.91147 7.97632 5.81479 7.60893 5.98176 7.3227Z"
      fill="#666D74"
    />
    <path
      d="M2.00002 8.90002C2.3314 8.90002 2.60002 9.16865 2.60002 9.50002V10.6554L3.80235 11.3568C4.08858 11.5237 4.18526 11.8911 4.01829 12.1773C3.85132 12.4636 3.48393 12.5603 3.1977 12.3933L1.6977 11.5183C1.51337 11.4108 1.40002 11.2134 1.40002 11V9.50002C1.40002 9.16865 1.66865 8.90002 2.00002 8.90002Z"
      fill="#666D74"
    />
    <path
      d="M14 8.90002C14.3314 8.90002 14.6 9.16865 14.6 9.50002V11C14.6 11.2134 14.4867 11.4108 14.3023 11.5183L12.8023 12.3933C12.5161 12.5603 12.1487 12.4636 11.9818 12.1773C11.8148 11.8911 11.9115 11.5237 12.1977 11.3568L13.4 10.6554V9.50002C13.4 9.16865 13.6687 8.90002 14 8.90002Z"
      fill="#666D74"
    />
    <path
      d="M8.00002 12.4C8.3314 12.4 8.60002 12.6687 8.60002 13V13.4554L9.1977 13.1068C9.48393 12.9398 9.85132 13.0365 10.0183 13.3227C10.1853 13.6089 10.0886 13.9763 9.80235 14.1433L8.30235 15.0183C8.11553 15.1273 7.88452 15.1273 7.6977 15.0183L6.1977 14.1433C5.91147 13.9763 5.81479 13.6089 5.98176 13.3227C6.14873 13.0365 6.51612 12.9398 6.80235 13.1068L7.40002 13.4554V13C7.40002 12.6687 7.66865 12.4 8.00002 12.4Z"
      fill="#666D74"
    />
  </svg>
);

export const CalendarIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50002 1.39999C4.8314 1.39999 5.10002 1.66862 5.10002 1.99999V2.89999H10.9V1.99999C10.9 1.66862 11.1687 1.39999 11.5 1.39999C11.8314 1.39999 12.1 1.66862 12.1 1.99999V2.89999H12.5C13.6598 2.89999 14.6 3.8402 14.6 4.99999V12.5C14.6 13.6598 13.6598 14.6 12.5 14.6H3.50002C2.34023 14.6 1.40002 13.6598 1.40002 12.5V4.99999C1.40002 3.8402 2.34023 2.89999 3.50002 2.89999H3.90002V1.99999C3.90002 1.66862 4.16865 1.39999 4.50002 1.39999ZM3.50002 4.09999C3.00297 4.09999 2.60002 4.50294 2.60002 4.99999V5.60208C2.8728 5.4725 3.17795 5.39999 3.50002 5.39999H12.5C12.8221 5.39999 13.1272 5.4725 13.4 5.60208V4.99999C13.4 4.50294 12.9971 4.09999 12.5 4.09999H3.50002ZM13.4 7.49999C13.4 7.00294 12.9971 6.59999 12.5 6.59999H3.50002C3.00297 6.59999 2.60002 7.00294 2.60002 7.49999V12.5C2.60002 12.9971 3.00297 13.4 3.50002 13.4H12.5C12.9971 13.4 13.4 12.9971 13.4 12.5V7.49999Z"
      fill="#666D74"
    />
  </svg>
);

export const XmarkIcon: SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={20}
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
);

export const CircleMinusIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.40015 7.9999C5.40015 7.66853 5.66878 7.3999 6.00015 7.3999H10.0001C10.3315 7.3999 10.6001 7.66853 10.6001 7.9999C10.6001 8.33127 10.3315 8.5999 10.0001 8.5999H6.00015C5.66878 8.5999 5.40015 8.33127 5.40015 7.9999Z"
      fill="#666D74"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.40015 7.9999C1.40015 4.35482 4.35507 1.3999 8.00015 1.3999C11.6452 1.3999 14.6001 4.35482 14.6001 7.9999C14.6001 11.645 11.6452 14.5999 8.00015 14.5999C4.35507 14.5999 1.40015 11.645 1.40015 7.9999ZM8.00015 2.5999C5.01781 2.5999 2.60015 5.01756 2.60015 7.9999C2.60015 10.9822 5.01781 13.3999 8.00015 13.3999C10.9825 13.3999 13.4001 10.9822 13.4001 7.9999C13.4001 5.01756 10.9825 2.5999 8.00015 2.5999Z"
      fill="#666D74"
    />
  </svg>
);

export const CardIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.90015 9.50015C2.90015 9.16878 3.16878 8.90015 3.50015 8.90015H7.50015C7.83152 8.90015 8.10015 9.16878 8.10015 9.50015C8.10015 9.83152 7.83152 10.1001 7.50015 10.1001H3.50015C3.16878 10.1001 2.90015 9.83152 2.90015 9.50015Z"
      fill="#666D74"
    />
    <path
      d="M2.90015 11.0001C2.90015 10.6688 3.16878 10.4001 3.50015 10.4001H5.50015C5.83152 10.4001 6.10015 10.6688 6.10015 11.0001C6.10015 11.3315 5.83152 11.6001 5.50015 11.6001H3.50015C3.16878 11.6001 2.90015 11.3315 2.90015 11.0001Z"
      fill="#666D74"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.900146 4.50015C0.900146 3.34035 1.84035 2.40015 3.00015 2.40015H13.0001C14.1599 2.40015 15.1001 3.34035 15.1001 4.50015V11.5001C15.1001 12.6599 14.1599 13.6001 13.0001 13.6001H3.00015C1.84035 13.6001 0.900146 12.6599 0.900146 11.5001V4.50015ZM2.10015 6.60015V11.5001C2.10015 11.9972 2.50309 12.4001 3.00015 12.4001H13.0001C13.4972 12.4001 13.9001 11.9972 13.9001 11.5001V6.60015H2.10015ZM13.9001 4.90015H2.10015V4.50015C2.10015 4.00309 2.50309 3.60015 3.00015 3.60015H13.0001C13.4972 3.60015 13.9001 4.00309 13.9001 4.50015V4.90015Z"
      fill="#666D74"
    />
  </svg>
);

export const UserSolidIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6ZM7.99913 9C6.17453 9 4.5782 9.97733 3.70508 11.437C4.71303 12.6947 6.26204 13.5 7.99913 13.5C9.73623 13.5 11.2852 12.6947 12.2932 11.437C11.4201 9.97733 9.82373 9 7.99913 9Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const PlaneIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.86908 2.29797C2.60248 2.25655 2.33418 2.3615 2.16646 2.57282C1.99873 2.78414 1.95744 3.06927 2.05831 3.31949L3.39039 6.62389C3.54291 7.00223 3.90994 7.25 4.31787 7.25H8.25C8.66421 7.25 9 7.58579 9 8C9 8.41421 8.66421 8.75 8.25 8.75H4.31812C3.9102 8.75 3.54317 8.99777 3.39065 9.37611L2.05831 12.6811C1.95744 12.9314 1.99873 13.2165 2.16646 13.4278C2.33418 13.6391 2.60248 13.7441 2.86908 13.7027C7.23525 13.0242 11.2273 11.2161 14.5368 8.58762C14.7159 8.44534 14.8204 8.22908 14.8204 8.00032C14.8204 7.77155 14.7159 7.55529 14.5368 7.41302C11.2273 4.78455 7.23525 2.97644 2.86908 2.29797Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const ClockIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8.75 3.75C8.75 3.33579 8.41421 3 8 3C7.58579 3 7.25 3.33579 7.25 3.75V8C7.25 8.41421 7.58579 8.75 8 8.75H11.25C11.6642 8.75 12 8.41421 12 8C12 7.58579 11.6642 7.25 11.25 7.25H8.75V3.75Z"
      fill="#ABB0B5"
    />
  </svg>
);

export const PaymentSuccessIcon: SVGComponent = (props) => (
  <svg width="92" height="93" viewBox="0 0 92 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_3788_2834)">
      <circle cx="45.9998" cy="46.5566" r="46" fill="white" fillOpacity="0.05" />
      <circle
        cx="45.9998"
        cy="46.5566"
        r="45.8203"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="0.359375"
      />
    </g>
    <g filter="url(#filter1_b_3788_2834)">
      <circle cx="46" cy="46.5566" r="37.0156" fill="#10B981" />
      <circle cx="46" cy="46.5566" r="36.8359" stroke="white" strokeOpacity="0.1" strokeWidth="0.359375" />
    </g>
    <g filter="url(#filter2_d_3788_2834)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2333 22.9781C38.6028 20.2531 42.0995 18.5254 46 18.5254C49.9003 18.5254 53.3969 20.2529 55.7664 22.9777C59.3691 22.7259 63.0637 23.9768 65.8221 26.7352C68.5804 29.4935 69.8313 33.1881 69.5796 36.7908C72.304 39.1603 74.0312 42.6567 74.0312 46.5566C74.0312 50.4573 72.3034 53.9543 69.5781 56.3238C69.8292 59.9259 68.5783 63.6198 65.8204 66.3776C63.0626 69.1355 59.3687 70.3864 55.7666 70.1353C53.3971 72.8602 49.9004 74.5879 46 74.5879C42.0998 74.5879 38.6032 72.8604 36.2337 70.1357C32.631 70.3875 28.9363 69.1366 26.1779 66.3782C23.4196 63.6199 22.1687 59.9252 22.4204 56.3225C19.696 53.953 17.9688 50.4566 17.9688 46.5566C17.9688 42.6565 19.6962 39.1599 22.4208 36.7904C22.1694 33.188 23.4203 29.4937 26.1784 26.7356C28.9365 23.9775 32.6309 22.7266 36.2333 22.9781ZM56.3796 41.3412C57.0718 40.3721 56.8473 39.0255 55.8783 38.3333C54.9092 37.6411 53.5626 37.8655 52.8704 38.8346L43.5686 51.8571L38.8997 47.1882C38.0576 46.3461 36.6924 46.3461 35.8503 47.1882C35.0082 48.0303 35.0082 49.3955 35.8503 50.2376L42.3191 56.7063C42.7672 57.1545 43.3899 57.3828 44.0216 57.3305C44.6533 57.2783 45.23 56.9507 45.5984 56.4349L56.3796 41.3412Z"
        fill="url(#paint0_linear_3788_2834)"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_3788_2834"
        x="-8.62525"
        y="-8.06836"
        width="109.25"
        height="109.25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.3125" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3788_2834" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3788_2834" result="shape" />
      </filter>
      <filter
        id="filter1_b_3788_2834"
        x="0.359374"
        y="0.916015"
        width="91.2813"
        height="91.2813"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.3125" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3788_2834" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3788_2834" result="shape" />
      </filter>
      <filter
        id="filter2_d_3788_2834"
        x="15.0938"
        y="17.0879"
        width="61.8125"
        height="61.8125"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.4375" />
        <feGaussianBlur stdDeviation="1.4375" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.137255 0 0 0 0 0.145098 0 0 0 0 0.160784 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3788_2834" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3788_2834" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3788_2834"
        x1="46"
        y1="18.5254"
        x2="46"
        y2="74.5879"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0.7" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export const HideWidgetIcon: SVGComponent = (props) => (
  <svg
    width="224"
    height="224"
    viewBox="0 0 224 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M112 210C57.876 210 14 166.11 14 112C14 57.89 57.876 14 112 14C166.124 14 210 57.89 210 112C210 166.11 166.124 210 112 210ZM112 0C50.141 0 0 50.12 0 112C0 173.88 50.141 224 112 224C173.859 224 224 173.88 224 112C224 50.12 173.859 0 112 0ZM154 105H70C66.129 105 63 108.15 63 112C63 115.85 66.129 119 70 119H154C157.871 119 161 115.85 161 112C161 108.15 157.871 105 154 105Z"
      fill="#585C62"
    />
  </svg>
);

export const ShowWidgetIcon: SVGComponent = (props) => (
  <svg
    width="224"
    height="224"
    viewBox="0 0 224 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M71.9995 104H152C154.121 104 156.156 104.843 157.656 106.343C159.157 107.843 160 109.878 160 112C160 114.122 159.157 116.157 157.656 117.657C156.156 119.157 154.121 120 152 120H71.9995C69.8778 120 67.8429 119.157 66.3427 117.657C64.8424 116.157 63.9995 114.122 63.9995 112C63.9995 109.878 64.8424 107.843 66.3427 106.343C67.8429 104.843 69.8778 104 71.9995 104Z"
      fill="#585C62"
    />
    <path
      d="M104 152V72C104 69.8783 104.843 67.8434 106.344 66.3431C107.844 64.8429 109.879 64 112 64C114.122 64 116.157 64.8429 117.657 66.3431C119.158 67.8434 120 69.8783 120 72V152C120 154.122 119.158 156.157 117.657 157.657C116.157 159.157 114.122 160 112 160C109.879 160 107.844 159.157 106.344 157.657C104.843 156.157 104 154.122 104 152Z"
      fill="#585C62"
    />
    <path
      d="M112 208C124.607 208 137.09 205.517 148.738 200.692C160.385 195.868 170.968 188.797 179.882 179.882C188.797 170.968 195.868 160.385 200.692 148.738C205.517 137.09 208 124.607 208 112C208 99.3931 205.517 86.9096 200.692 75.2624C195.868 63.6151 188.797 53.0322 179.882 44.1177C170.968 35.2033 160.385 28.132 148.738 23.3076C137.09 18.4831 124.607 16 112 16C86.5392 16 62.1212 26.1143 44.1177 44.1177C26.1143 62.1212 16 86.5392 16 112C16 137.461 26.1143 161.879 44.1177 179.882C62.1212 197.886 86.5392 208 112 208ZM112 224C82.2958 224 53.8081 212.2 32.804 191.196C11.8 170.192 0 141.704 0 112C0 82.2958 11.8 53.8081 32.804 32.804C53.8081 11.8 82.2958 0 112 0C141.704 0 170.192 11.8 191.196 32.804C212.2 53.8081 224 82.2958 224 112C224 141.704 212.2 170.192 191.196 191.196C170.192 212.2 141.704 224 112 224Z"
      fill="#585C62"
    />
  </svg>
);

export const DownloadIcon: SVGComponent = (props) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M52.8386 73.1082C52.1099 73.9051 51.0801 74.359 50.0001 74.359C48.9201 74.359 47.8904 73.9051 47.1617 73.1082L26.6487 50.6723C25.2154 49.1046 25.3243 46.6718 26.892 45.2385C28.4598 43.8051 30.8925 43.9138 32.3259 45.4815L46.154 60.6062V3.84615C46.154 1.722 47.876 0 50.0001 0C52.1242 0 53.8463 1.722 53.8463 3.84615V60.6062L67.6745 45.4815C69.1078 43.9138 71.5406 43.8051 73.1083 45.2385C74.676 46.6718 74.7847 49.1046 73.3514 50.6723L52.8386 73.1082Z"
      fill="#585C62"
    />
    <path
      d="M7.69231 65.3846C7.69231 63.2605 5.97036 61.5385 3.84616 61.5385C1.722 61.5385 2.68694e-06 63.2605 2.68694e-06 65.3846V65.6661C-9.98772e-05 72.6795 -0.000202809 78.3323 0.597541 82.7785C1.21816 87.3943 2.5458 91.2805 5.63257 94.3672C8.71934 97.4543 12.6058 98.782 17.2218 99.4025C21.6678 100 27.3207 100 34.334 100H65.6662C72.6795 100 78.3323 100 82.7785 99.4025C87.3944 98.782 91.2805 97.4543 94.3677 94.3672C97.4544 91.2805 98.7821 87.3943 99.4026 82.7785C100 78.3323 100 72.6795 100 65.6661V65.3846C100 63.2605 98.278 61.5385 96.1538 61.5385C94.0297 61.5385 92.3077 63.2605 92.3077 65.3846C92.3077 72.7456 92.2995 77.8795 91.779 81.7533C91.2728 85.5164 90.3477 87.5087 88.9282 88.9282C87.5087 90.3477 85.5164 91.2728 81.7533 91.779C77.8795 92.2995 72.7456 92.3077 65.3846 92.3077H34.6154C27.2543 92.3077 22.1204 92.2995 18.2468 91.779C14.4838 91.2728 12.4911 90.3477 11.0718 88.9282C9.65257 87.5087 8.72718 85.5164 8.22128 81.7533C7.70046 77.8795 7.69231 72.7456 7.69231 65.3846Z"
      fill="#585C62"
    />
  </svg>
);

export const LeftArrowIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78033 4.21967C10.0732 4.51256 10.0732 4.98744 9.78033 5.28033L7.06066 8L9.78033 10.7197C10.0732 11.0126 10.0732 11.4874 9.78033 11.7803C9.48744 12.0732 9.01256 12.0732 8.71967 11.7803L5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967L8.71967 4.21967C9.01256 3.92678 9.48744 3.92678 9.78033 4.21967Z"
      fill="#666D74"
    />
  </svg>
);

export const RightArrowIcon: SVGComponent = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.21967 11.7803C5.92678 11.4874 5.92678 11.0126 6.21967 10.7197L8.93934 8L6.21967 5.28033C5.92678 4.98744 5.92678 4.51256 6.21967 4.21967C6.51256 3.92678 6.98744 3.92678 7.28033 4.21967L10.5303 7.46967C10.8232 7.76256 10.8232 8.23744 10.5303 8.53033L7.28033 11.7803C6.98744 12.0732 6.51256 12.0732 6.21967 11.7803Z"
      fill="#666D74"
    />
  </svg>
);
